import * as _ from 'lodash'
import {BehaviorSubject} from 'rxjs'
import {
    IBusinessObject,
    IBusinessObjectChanges,
    IBusinessObjectChangesOptions
} from '../PA.Core/PA.Core.IF.BO';
import {
    IHaveSourceCustomers, IHaveProductGroups, IHaveExecutionDates, IHaveFinishedProducts,
    IHaveExecutionBounds, IHaveTags, IHaveSecurity, IHaveCircular
} from '../PA.Core/PA.Core.IF.Aspects';
import {
    IHavePlan,
    IEventSpend,
    IEventSpendAddOptions,
    IEventSpendChangedEvent,
    IEventRedistributedSpend,
    IEventRedistributedSpendAddOptions,
    IEventRedistributedSpendChangedEvent,
    IEventSourceCustomer,
    IEventSourceCustomerChangedEvent,
    IEvent,
    IEventProductGroup,
    IEventChangedEvent,
    IEventProductGroupChangedEvent,
    IEventProductGroupAddOptions,
    IEventSourceCustomerAddOptions,
    IEventRedistributedSpendSyncOptions,
    IEventRedistributedSpendAddOptionsDefault,
    IEventRedistributedSpendRemoveOptions,
    IEventRedistributedSpendRemoveOptionsDefault,
    IEventRedistributedSpendSyncOptionsDefault,
    IHaveEventParentRelationship,
    IHaveEventFunding, IEventFundingChangedEvent
} from '../PA.TPM.Core/PA.TPM.IF.Aspects'
import {IEventActualsCalculator, IHaveEventActualsCalculator} from '../PA.TPM.Services/PA.TPM.Services.IF'
import {IEventStandardCalculator, IHaveEventStandardCalculator} from '../PA.TPM.Services/PA.TPM.Services.IF'
import {IIdentityProvider, IProgressProvider, IMessageProvider, IDateRange} from '../PA.Core/PA.Core.IF.Basic';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {ICircularRow} from '../PA.Core/PA.Core.IF.Aspects'
import {ASync} from '../PA.Core/Basic/ASync'
import {DateUtils} from '../PA.Core/Basic/Dates'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {PAdbContext} from '../PA.Core/PAdbContext';
import {
    esWB_Plan,
    esWB_Meta,
    esWB_Product_Group,
    esWB_Finished_Product,
    esWB_Customer,
    esWB_Metric,
    esWB_Event,
    esWB_Event_Override,
    esWB_Event_Product_Group,
    esWB_Source,
    esWB_Event_Product,
    esWB_Event_Customer,
    esWB_Tag,
    esWB_Event_Tag,
    esWB_Event_Meta,
    esWB_Event_Spend_PrdGrp,
    esWB_Event_Product_Group_Override,
    esWB_Event_Spend_Prd,
    esWB_Event_Spend_PrdGrp_Customer,
    esWB_Event_Spend_PrdGrp_Override,
    esWB_Event_Spend_PrdGrp_Redistrib,
    esWB_Spend_Type,
    esWB_Domain_Item,
    esWB_Plan_Type,
    esWB_Event_Relationship,
    esWB_Event_Type,
    esWB_BusinessUnit,
    esWB_Circular_Config,
    esWB_Customer_Relationship,
    esWB_Product_Group_Relationship,
    esWB_Circular,
    esWB_Event_Circular, esWB_EventFR, esWB_EvtShipPrd, esWB_EvtShipCPrd, esWB_EvtSShpPrd, esWB_EvtSShpPrdO
} from "../PA.Core/PAdbSchema";

import {
    WB_CustomerRow,
    WB_ProductGroupRow,
    WB_FinishedProductRow,
    WB_EventRow,
    WB_EventProductRow,
    WB_EventOverrideRow,
    WB_MetricRow,
    WB_EventProductGroupRow,
    WB_EventProductGroupOverrideRow,
    WB_EventSpendPrdGrpOverrideRow,
    WB_EventSpendPrdGrpRow,
    WB_EventCustomerRow,
    WB_TagRow,
    WB_EventTagRow,
    WB_PlanProductRow,
    WB_EventSpendPrdGrpRedistribRow,
    WB_EventSpendPrdRow,
    WB_EventSpendPrdGrpCustomerRow,
    WB_MetaRow,
    WB_EventMetaRow,
    WB_PlanProductGroupRow,
    WB_EventRelationshipRow,
    WB_CircularRow,
    WB_CircularConfigRow,
    WB_EventCircularRow,
    WB_CustomerRelationshipRow,
    WB_BusinessUnitRow,
    WB_EventFRRow,
    WB_EvtShipPrdRow,
    WB_EvtShipCPrdRow, WB_EvtSShpPrdRow, WB_EvtSShpPrdOverrideRow
} from '../PA.Core/PAdbSchemaRows';

import {CustomerHierarchyService} from "../PA.MD.Services/CustomerHierarchyService";
import {ProductHierarchyService} from "../PA.MD.Services/ProductHierarchyService";

import {SourceCustomerService} from '../PA.MD.Services/SourceCustomerService'
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {TagBag} from "../PA.Utils/TagBag";
import {PlanBO} from "./PlanBO";
import {PAusrContext} from "../PA.Core/PAusrContext";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {EventActualsCalculator} from "../PA.TPM.Services/EventActualsCalculator";
import {EventStandardCalculator} from "../PA.TPM.Services/EventStandardCalculator";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {RecordUtils} from "../PA.Core/Basic/Records";
import {IPolicyCollection} from "../PA.Core/PA.Core.IF.Policy";
import {PolicyCollection} from "../PA.Core/Security/PolicyCollection";
import {PolicyHasRole} from "../PA.Core/Security/PolicyHasRole";
import {PolicyBOis} from '../PA.Core/Security/PolicyBOis';
import {IHaveEditorLock, ILock, ILockOptions} from "../PA.Concurrency.Core/PA.Concurrency.IF.Lock";
import {PALockClient} from "../PA.Concurrency.Services/PALockClient";
import {IHaveRefCounter, IRefCounter} from "../PA.Concurrency.Core/PA.Concurrency.IF.RefCounter";
import {RefCounter} from "../PA.Concurrency.Core/RefCounter";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";
import {MDUsageService} from "../PA.MD.Services/MDUsageService";


//<editor-fold desc = "Event BO Options Interface and Defaults ">

export interface IEventCreateOptions {
    bEagerLoadAspectInterfaces?: boolean
    dbContext?: PAdbContext
    Plan?: PlanBO
}

const EventCreateOptions_default: IEventCreateOptions = {
    bEagerLoadAspectInterfaces: false
}

export interface IEventLoadOptions {
    dbContext?: PAdbContext
    Plan?: PlanBO,
    WB_Plan_ID?: number
}

const EventLoadOptions_default: IEventLoadOptions = {}

export interface IEventSaveValidateOptions {
    Validate?: {
        bSkipAllValidations?: boolean,
        bSkipDateValidation?: boolean,
        bSkipSpendValidation?: boolean,
        bSkipTagValidation?: boolean,
        bSkipVolumeOverrideValidation?: boolean,
        bSkipBasePriceOverrideValidation?: boolean
    },
    Save?: {},
    bIncludeEventCollection?: boolean
}

const EventSaveValidateOptions_default: IEventSaveValidateOptions = {
    Validate: {
        bSkipAllValidations: false,
        bSkipDateValidation: false,
        bSkipSpendValidation: false,
        bSkipTagValidation: false,
        bSkipVolumeOverrideValidation: false,
        bSkipBasePriceOverrideValidation: false
    },
    Save: {},
    bIncludeEventCollection: false
}


export interface IEventDeleteOptions {
}

const EventDeleteOptions_default: IEventDeleteOptions = {}


export interface IEventCopyOptions {
    bIncludeEventSubCustomers?: boolean,
    bIncludeEventProductGroups?: boolean,
    bUsePlanProducts?: boolean,
    bIncludeEventProductGroupSpend?: boolean,
    bIncludeEventRedistributedSpend?: boolean,
    bIncludeEventTags?: boolean,
    bIncludeEventMetas?: boolean

    [id: string]: any
}

const EventCopyOptions_default: IEventCopyOptions = {
    bIncludeEventSubCustomers: true,
    bIncludeEventProductGroups: true,
    bIncludeEventTags: true,
    bIncludeEventProductGroupSpend: false,
    bIncludeEventRedistributedSpend: false,
    bIncludeEventMetas: false
}


//</editor-fold desc>

export class EventBO
    implements IBusinessObject,
        IEvent,
        IEventProductGroup,
        IEventSourceCustomer,
        IEventSpend,
        IEventRedistributedSpend,
        IHaveSourceCustomers,
        IHaveProductGroups,
        IHaveFinishedProducts,
        IHaveExecutionDates,
        IHaveExecutionBounds,
        IHaveTags,
        IHavePlan,
        IHaveSecurity,
        IHaveEventActualsCalculator,
        IHaveEventStandardCalculator,
        IHaveEditorLock,
        IHaveRefCounter,
        IHaveEventParentRelationship,
        IHaveEventFunding,
        IHaveCircular
    // IRecordResolverProvider  <static>
{

    //<editor-fold desc = "Event Attributes and Constructor">

    CreateOptions: IEventCreateOptions
    Identity: IdentityProvider;

    LoadOptions: IEventLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    _bIsLoadedInternal: boolean;
    _OnLoadCompleteInternal: Promise<EventBO>
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    _bDeleteOnSave: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Event: WB_EventRow;

    usrContext: PAusrContext;
    bRecordMRU: boolean;


    constructor(options: IEventCreateOptions) {

        this.CreateOptions = options || {}

        if ('dbContext' in this.CreateOptions) {
            this.dbContext = this.CreateOptions.dbContext
        }

        this.IHavePlan_init()
        if ('Plan' in this.CreateOptions) {
            this.setPlan(this.CreateOptions.Plan)
            this.dbContext = this.CreateOptions.Plan.dbContext
        }

        this.usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        this.Identity = new IdentityProvider({id: 0, name: 'Undefined Event'})

        this.LoadOptions = {}
        this._bIsLoaded = false
        this._bIsLoadedInternal = false

        this._OnLoadComplete = undefined
        this._OnLoadCompleteInternal = undefined
        this.LoadProgressProvider = new ProgressProvider('Loading', this)

        this.ValidateOptions = {}
        this._bIsValidated = false
        this.ValidateMessageProvider = new MessageProvider()
        this.ValidateProgressProvider = new ProgressProvider("Validating", this)

        this.SaveOptions = {}
        this._bIsSaved = false
        this.SaveProgressProvider = new ProgressProvider("Saving", this)

        this.DeleteOptions = {}
        this._bIsDeleted = false
        this._bDeleteOnSave = false
        this.DeleteMessageProvider = new MessageProvider()
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this)
        this.bRecordMRU = true

        this.IEvent_init()
        this.IEventProductGroup_init()
        this.IEventSourceCustomer_init()
        this.IEventSpend_init()
        this.IEventRedistributedSpend_init()

        this.IHaveSourceCustomers_init()
        this.IHaveProductGroups_init()
        this.IHaveFinishedProducts_init()
        this.IHaveExecutionDates_init()
        this.IHaveExecutionBounds_init()
        this.IHaveTagsLoaded_init()
        this.IHaveEventActualsCalculator_init()
        this.IHaveEventStandardCalculator_init()
        this.IHaveSecurity_init()
        this.RefCounter_Init()
        this.IHaveEventParentRelationship_init()
        this.IHaveCircular_Init()
        this.IHaveEventFunding_init()
    }

    //</editor-fold>

    get WB_Event(): WB_EventRow {
        return this.drWB_Event;
    }

    //<editor-fold desc = "IBusinessObject operations">


    LoadNew(options?: any): Promise<IBusinessObject> {
        const self = this;


        self.LoadProgressProvider.start("Creating Event");

        self._OnLoadCompleteInternal = new Promise<EventBO>((resolve, error) => {
            if (self.bIsLoaded) {
                // "Event already loaded.";
                resolve(self);
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, EventLoadOptions_default)

            let iPlanId: number = undefined

            if ('Plan' in self.LoadOptions) {
                self.setPlan(self.LoadOptions.Plan)
                iPlanId = self.LoadOptions.Plan.WB_Plan.cif.WB_PLAN_ID
                self.dbContext = self.LoadOptions.Plan.dbContext
            } else if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }


            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for new Event.");
                return;
            }

            if (!_.isEmpty(self.Plan)) {
                iPlanId = self.Plan.WB_Plan.cif.WB_PLAN_ID
            }

            if ((!iPlanId) && (self.LoadOptions.WB_Plan_ID)) {
                iPlanId = self.LoadOptions.WB_Plan_ID
            }

            if (!_.isNumber(iPlanId)) {
                error("Unable to determine Plan Id for new Event.");
                return;
            }

            self.dbContext.createRecordWithKey(esWB_Event)
                .then((newRecord: WB_EventRow) => {
                    newRecord.cif.WB_PLAN_ID = iPlanId
                    self.dbContext.add(esWB_Event, newRecord)
                    self.drWB_Event = newRecord

                    self.Identity.setAll(self.WB_Event.cif.WB_EVT_ID, self.WB_Event.cif.EVENT_ID, self.WB_Event.cif.EVENT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                    return self.drWB_Event.loadRelations([esWB_Plan, esWB_Meta, esWB_Source])

                }).then((ignore) => {
                if (self.drWB_Event.WB_PlanRow) {
                    self.WB_Event.WB_CustomerRow_Planning = self.WB_Event.WB_PlanRow.WB_CustomerRow_Planning
                    self.WB_Event.WB_CustomerRow_SubPlanning = self.WB_Event.WB_PlanRow.WB_CustomerRow_SubPlanning
                }
                self.Identity.listenToRecordUpdates(self.WB_Event, 'WB_EVENT_ID', 'EVENT_ID', 'EVENT_NAME')
                resolve(self)
            }).catch((err) => {
                error(err)
            })
        });


        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self._OnLoadCompleteInternal
                .then((aBO) => {

                    self._bIsLoadedInternal = true
                    self._OnLoadCompleteInternal = undefined
                    return self._AfterBoLoadCompleteInternal()

                }).then((ignored) => {
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()

                if (self.CreateOptions.bEagerLoadAspectInterfaces) {
                    self.OnIHaveSourceCustomersLoaded
                    self.OnIHaveProductGroupsLoaded
                    self.OnIHaveFinishedProductsLoaded
                    self.OnIHaveExecutionDatesLoaded
                    self.OnIHaveExecutionBoundsLoaded
                    self.OnIHaveTagsLoaded
                }
                resolve(self)

            })
                .catch((err) => {
                    self._OnLoadCompleteInternal = undefined;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    resolve(self)
                })
        })

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        self._OnLoadCompleteInternal = new Promise<EventBO>((resolve, error) => {

            if (self.bIsLoaded) {
                resolve(self); // "Event already loaded.";
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, EventLoadOptions_default)


            if ('Plan' in self.LoadOptions) {
                self.setPlan(self.LoadOptions.Plan)
                self.dbContext = self.LoadOptions.Plan.dbContext
            } else if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }
            if ('bRecordMRU' in self.LoadOptions) {
                // @ts-ignore
                self.bRecordMRU = self.LoadOptions.bRecordMRU
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for Event.")
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = EventBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = EventBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aEventRow: any = recordResolver.get(esWB_Event, anId)

                    if (_.isEmpty(aEventRow)) {
                        console.log("Event Record Resolver unable to locate Event for id: ", anId)
                        error("Event not Found");
                        return;
                    }

                    self.drWB_Event = aEventRow;
                    self.Identity.setAll(self.WB_Event.cif.WB_EVT_ID, self.WB_Event.cif.EVENT_ID, self.WB_Event.cif.EVENT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Event, 'WB_EVENT_ID', 'EVENT_ID', 'EVENT_NAME')

                    resolve(self)
                }).catch(function (err: any) {
                error(err)
                return;
            });
        });

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self._OnLoadCompleteInternal
                .then((aBO) => {

                    self._bIsLoadedInternal = true
                    self._OnLoadCompleteInternal = undefined
                    return self._AfterBoLoadCompleteInternal()

                }).then((ignored) => {
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()

                if (self.CreateOptions.bEagerLoadAspectInterfaces) {
                    self.OnIHaveSourceCustomersLoaded
                    self.OnIHaveProductGroupsLoaded
                    self.OnIHaveFinishedProductsLoaded
                    self.OnIHaveExecutionDatesLoaded
                    self.OnIHaveExecutionBoundsLoaded
                    self.OnIHaveTagsLoaded
                }
                resolve(self)
            })
                .catch((err) => {
                    self._OnLoadCompleteInternal = undefined;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    resolve(self)
                })
        })

        return this._OnLoadComplete;

    }

    private _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        return new Promise<void>((resolve, error) => {
            var tasks: Promise<any>[] = [];
            self.LoadProgressProvider.setProgressMessage('EventBO.PostLoad', 'Processing Loaded Data');
            tasks.push(self._RunAfterCreates_OnBoLoadComplete())
            Promise.all(tasks)
                .then(() => {
                    return self.getCircularConfig(self.WB_Event.WB_PlanRow?.WB_PlanTypeRow?.cif.WB_BUSINESSUNIT_ID)
                })
                .then((result: WB_CircularConfigRow) => {
                    self._circularConfig = result
                    return self.IHaveEventActualsCalculator_OnLoadComplete()
                })
                .then((results: any) => {
                    return self.IHaveEventStandardCalculator_OnLoadComplete()
                })
                .then((results: any) => {
                    return self.IHaveSecurity_OnLoadComplete()
                })
                .then((results: any) => {
                    if (!this.RefCounter.RefCount)
                        self.RefCounter.acquireReference()

                    if (self.bRecordMRU && _.isNumber(self.drWB_Event.WB_PlanRow.cif.WB_SALESORG_ID) && self.drWB_Event.WB_PlanRow.cif.WB_SALESORG_ID > 0) {
                        let mruService = new MDUsageService()
                        return mruService.saveSalesOrgUsage(self.drWB_Event.cif.WB_SALESORG_ID)
                    } else {
                        resolve();
                        return;
                    }
                })
                .then(() => {
                    resolve();
                })
                .catch((err: any) => {
                    error(err);
                });
        })
    }

    private _RunAfterCreates_OnBoLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            let saveContext: PAdbContext = undefined
            self._EventRow_AfterCreate(self.WB_Event)
                .then((ignore2) => {

                    let tasks: Promise<any>[] = [];

                    _.forEach(self.WB_Event.WB_Event_ProductGroupRows, (epg: WB_EventProductGroupRow) => {
                        tasks.push(self._EventProductGroupRow_AfterCreate(epg));
                    });

                    _.forEach(self.WB_Event.WB_Event_SourceCustomerRows, (esc: WB_EventCustomerRow) => {
                        tasks.push(self._EventSourceCustomerRow_AfterCreate(esc));
                    });

                    _.forEach(self.WB_Event.WB_EventSpend_ProductGroupRows, (espg: WB_EventSpendPrdGrpRow) => {
                        tasks.push(self._EventSpendProductGroupRow_AfterCreate(espg));
                    });

                    _.forEach(self.WB_Event.WB_EventSpend_RedistributionRows, (erspg: WB_EventSpendPrdGrpRedistribRow) => {
                        tasks.push(self._EventRedistribSpendProductGroupRow_AfterCreate(erspg));
                    });

                    return Promise.all(tasks);

                }).then((ignore) => {
                //save all of the newly created records automatically so we don't keep using new keys
                //return;  // Skip saving on load.. let nightly batch calc save records.
                saveContext = self.dbContext //context just for saving records
                saveContext.BatchStart();
                let tasks: Promise<any>[] = [];
                let evtPGRows: WB_EventProductGroupRow[] = [];
                let evtPGOverrideRows: WB_EventProductGroupOverrideRow[] = [];
                let wbMetricRows: WB_MetricRow[] = [];

                if (!self.WB_Event.WB_EventOverrideRow._rowExists || self.WB_Event.WB_EventOverrideRow.hasChanges()) {
                    tasks.push(saveContext.SaveBatch(esWB_Event_Override, self.WB_Event.WB_EventOverrideRow));
                }

                if (!_.isEmpty(self.WB_Event.WB_EventOverrideRow)) {
                    let ovrRow = self.WB_Event.WB_EventOverrideRow
                    if (!_.isEmpty(ovrRow.WB_MetricRow_Funding) && (!ovrRow.WB_MetricRow_Funding._rowExists || ovrRow.WB_MetricRow_Funding.hasChanges())) {
                        wbMetricRows.push(ovrRow.WB_MetricRow_Funding);
                    }

                    if (!_.isEmpty(ovrRow.WB_MetricRow_Actual) && (!ovrRow.WB_MetricRow_Actual._rowExists || ovrRow.WB_MetricRow_Actual.hasChanges())) {
                        wbMetricRows.push(ovrRow.WB_MetricRow_Actual);
                    }
                    if (!_.isEmpty(ovrRow.WB_MetricRow_ActualOvrd) && (!ovrRow.WB_MetricRow_ActualOvrd._rowExists || ovrRow.WB_MetricRow_ActualOvrd.hasChanges())) {
                        wbMetricRows.push(ovrRow.WB_MetricRow_ActualOvrd);
                    }
                }

                _.forEach(self.WB_Event.WB_Event_ProductGroupRows, (epg: WB_EventProductGroupRow) => {
                    if (!epg._rowExists || epg.hasChanges()) {
                        evtPGRows.push(epg);
                    }

                    if (!_.isEmpty(epg.WB_EventProductGroupOverrideRow)) {
                        return;
                    }

                    let epgOverride: WB_EventProductGroupOverrideRow = epg.WB_EventProductGroupOverrideRow;
                    if (!(epgOverride._rowExists) || epgOverride.hasChanges()) {
                        evtPGOverrideRows.push(epgOverride);
                    }

                    if (!_.isEmpty(epgOverride.WB_MetricRow_Actual) && (!epgOverride.WB_MetricRow_Actual._rowExists || epgOverride.WB_MetricRow_Actual.hasChanges())) {
                        wbMetricRows.push(epgOverride.WB_MetricRow_Actual);
                    }
                    if (!_.isEmpty(epgOverride.WB_MetricRow_ActualOvrd) && (!epgOverride.WB_MetricRow_ActualOvrd._rowExists || epgOverride.WB_MetricRow_ActualOvrd.hasChanges())) {
                        wbMetricRows.push(epgOverride.WB_MetricRow_ActualOvrd);
                    }

                    if (!_.isEmpty(epg.WB_MetricRow_Planned) && (!epg.WB_MetricRow_Planned._rowExists || epg.WB_MetricRow_Planned.hasChanges())) {
                        wbMetricRows.push(epg.WB_MetricRow_Planned);
                    }


                });
                tasks.push(saveContext.SaveBatch(esWB_Event_Product_Group, evtPGRows));
                tasks.push(saveContext.SaveBatch(esWB_Event_Product_Group_Override, evtPGOverrideRows));

                let escRows: WB_EventCustomerRow[] = [];
                _.forEach(self.WB_Event.WB_Event_SourceCustomerRows, (esc: WB_EventCustomerRow) => {
                    if (!esc._rowExists || esc.hasChanges()) {
                        escRows.push(esc);
                    }
                });
                tasks.push(saveContext.SaveBatch(esWB_Event_Customer, escRows));

                let espgRows: WB_EventSpendPrdGrpRow[] = [];
                let espgOverrideRows: WB_EventSpendPrdGrpOverrideRow[] = [];
                _.forEach(self.WB_Event.WB_EventSpend_ProductGroupRows, (espg: WB_EventSpendPrdGrpRow) => {
                    if (!espg._rowExists || espg.hasChanges()) {
                        espgRows.push(espg);
                    }

                    if (_.isEmpty(espg.WB_EventSpendPrdGrpOverrideRow)) {
                        return;
                    }

                    let espgo: WB_EventSpendPrdGrpOverrideRow = espg.WB_EventSpendPrdGrpOverrideRow;
                    if (!espgo._rowExists || espgo.hasChanges()) {
                        espgOverrideRows.push(espgo);
                    }

                    if (!_.isEmpty(espgo.WB_MetricRow_Actual) && (!espgo.WB_MetricRow_Actual._rowExists || espgo.WB_MetricRow_Actual.hasChanges())) {
                        wbMetricRows.push(espgo.WB_MetricRow_Actual);
                    }

                    if (!_.isEmpty(espgo.WB_MetricRow_ActualOvrd && (!espgo.WB_MetricRow_ActualOvrd._rowExists || espgo.WB_MetricRow_ActualOvrd.hasChanges()))) {
                        wbMetricRows.push(espgo.WB_MetricRow_ActualOvrd);
                    }

                });
                tasks.push(saveContext.SaveBatch(esWB_Event_Spend_PrdGrp, espgRows));
                tasks.push(saveContext.SaveBatch(esWB_Event_Spend_PrdGrp_Override, espgOverrideRows));

                let erspgRows: WB_EventSpendPrdGrpRedistribRow[] = [];
                _.forEach(self.WB_Event.WB_EventSpend_RedistributionRows, (erspg: WB_EventSpendPrdGrpRedistribRow) => {
                    if (!erspg._rowExists || erspg.hasChanges()) {
                        erspgRows.push(erspg);
                    }

                    if (!_.isEmpty(erspg.WB_MetricRow_Overlap) && (!erspg.WB_MetricRow_Overlap._rowExists || erspg.WB_MetricRow_Overlap.hasChanges())) {
                        wbMetricRows.push(erspg.WB_MetricRow_Overlap);
                    }
                });


                tasks.push(saveContext.SaveBatch(esWB_Event_Spend_PrdGrp_Redistrib, erspgRows));
                tasks.push(saveContext.SaveBatch(esWB_Metric, wbMetricRows));
                return Promise.all(tasks);
            }).then((ignore) => {
                if (saveContext)
                    return saveContext.BatchComplete();
            }).then((ignore) => {
                resolve();
            }).catch((err) => {
                error(err);
            });
        });
    }

    private _EventRow_AfterCreate(anEventRow: WB_EventRow): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            let bAdded = false

            // Synchronous part
            let drOverrides: WB_EventOverrideRow;
            if (!_.isEmpty(anEventRow.WB_EventOverrideRow)) {
                drOverrides = <WB_EventOverrideRow>anEventRow.WB_EventOverrideRow;
            } else {
                drOverrides = <any>(self.dbContext.createRecord(esWB_Event_Override));
                drOverrides.setDefaults()
                drOverrides.cif.WB_EVT_ID = anEventRow.cif.WB_EVT_ID;
                self.dbContext.add(esWB_Event_Override, drOverrides)
                anEventRow.WB_EventOverrideRow = drOverrides;
            }

            // Async part(s)

            // Create Metrics row(s) as needed

            ASync.resolve()
                .then((ignore) => {
                    if (!_.isEmpty(drOverrides.WB_MetricRow_Actual)) {
                        return ASync.resolve()
                    }

                    return self.dbContext.createRecordWithKey(esWB_Metric)
                        .then((drMetrics: WB_MetricRow) => {
                            drMetrics.setDefaults()
                            drMetrics.cif.WB_EVT_ID = anEventRow.cif.WB_EVT_ID
                            drMetrics.cif.WB_PLAN_ID = anEventRow.cif.WB_PLAN_ID
                            drMetrics.cif.REFERENCE_LEVEL_ID = 'Event'
                            drMetrics.cif.METRIC_TYPE_ID = 'Actual'
                            drMetrics.cif.REFERENCE_ID = anEventRow.cif.WB_EVT_ID
                            drMetrics.cif.REFERENCE_ID_UI = anEventRow.cif.EVENT_ID;
                            drMetrics.cif.WB_PRDGRP_ID = 0;
                            self.dbContext.add(esWB_Metric, drMetrics);
                            drOverrides.WB_MetricRow_Actual = drMetrics;
                        })

                }).then((ignore) => {

                // Create Actual Override Record if Needed

                if (!_.isEmpty(drOverrides.WB_MetricRow_ActualOvrd)) {
                    return ASync.resolve()
                }

                return self.dbContext.createRecordWithKey(esWB_Metric)
                    .then((drMetrics: WB_MetricRow) => {
                        drMetrics.setDefaults()
                        drMetrics.cif.WB_EVT_ID = anEventRow.cif.WB_EVT_ID
                        drMetrics.cif.WB_PLAN_ID = anEventRow.cif.WB_PLAN_ID
                        drMetrics.cif.REFERENCE_LEVEL_ID = 'Event'
                        drMetrics.cif.METRIC_TYPE_ID = 'ActualOvrd'
                        drMetrics.cif.REFERENCE_ID = anEventRow.cif.WB_EVT_ID
                        drMetrics.cif.REFERENCE_ID_UI = anEventRow.cif.EVENT_ID;
                        drMetrics.cif.WB_PRDGRP_ID = 0;
                        self.dbContext.add(esWB_Metric, drMetrics);
                        drOverrides.WB_MetricRow_ActualOvrd = drMetrics;
                    })

            }).then((ignore) => {

                // Create funding metric Record if Needed
                if (!_.isEmpty(drOverrides.WB_MetricRow_Funding)) {
                    return ASync.resolve()
                }
                return self.dbContext.createRecordWithKey(esWB_Metric)
                    .then((drMetrics: WB_MetricRow) => {
                        drMetrics.setDefaults()
                        drMetrics.cif.WB_EVT_ID = anEventRow.cif.WB_EVT_ID
                        drMetrics.cif.WB_PLAN_ID = anEventRow.cif.WB_PLAN_ID
                        drMetrics.cif.REFERENCE_LEVEL_ID = 'Event'
                        drMetrics.cif.METRIC_TYPE_ID = 'Funding Override'
                        drMetrics.cif.REFERENCE_ID = anEventRow.cif.WB_EVT_ID
                        drMetrics.cif.REFERENCE_ID_UI = anEventRow.cif.EVENT_ID;
                        drMetrics.cif.WB_PRDGRP_ID = 0;
                        self.dbContext.add(esWB_Metric, drMetrics);
                        drOverrides.cif.WB_METRIC_ID_FUNDING = drMetrics.cif.WB_METRIC_ID
                        drOverrides.WB_MetricRow_Funding = drMetrics;

                    })

            })
                .then(() => {

                })
                .then((ignore4) => {
                    // Wire up Change Events
                    anEventRow.setupOnChangeEvents([], self.IEvent_onRecordChange.bind(self), self)
                    if (!_.isEmpty(anEventRow.WB_EventOverrideRow)) {
                        anEventRow.WB_EventOverrideRow.setupOnChangeEvents([], self.IEventOverride_onRecordChange.bind(self), self)
                    }

                    resolve()
                }).catch((err) => {
                error(err)
            })

        });

    }

    private _EventProductGroupRow_AfterCreate(anEventPGRow: WB_EventProductGroupRow): Promise<void> {
        const self = this
        const anEPG: WB_EventProductGroupRow = anEventPGRow

        return new Promise<void>((resolve, error) => {

            let tasks: Promise<any>[] = []
            let anEPGO: WB_EventProductGroupOverrideRow
            if (!_.isEmpty(anEventPGRow.WB_EventProductGroupOverrideRow)) {
                anEPGO = anEventPGRow.WB_EventProductGroupOverrideRow
            } else {
                anEPGO = <any>self.dbContext.createRecord(esWB_Event_Product_Group_Override)
                anEPGO.setDefaults()
                anEPGO.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                anEPGO.cif.WB_EVTPG_ID = anEPG.cif.WB_EVTPG_ID
                anEPGO.cif.WB_PRDGRP_ID = anEPG.cif.WB_PRDGRP_ID
                self.dbContext.add(esWB_Event_Product_Group_Override, anEPGO)
                anEPG.WB_EventProductGroupOverrideRow = anEPGO
            }

            if (_.isEmpty(anEPGO.WB_MetricRow_Actual)) {
                tasks.push(
                    self.dbContext.createRecordWithKey(esWB_Metric)
                        .then((drMetrics: WB_MetricRow) => {
                            drMetrics.setDefaults()
                            drMetrics.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                            drMetrics.cif.WB_PLAN_ID = self.WB_Event.cif.WB_PLAN_ID
                            drMetrics.cif.WB_PRDGRP_ID = anEPG.cif.WB_PRDGRP_ID;
                            drMetrics.cif.REFERENCE_LEVEL_ID = 'EventPG'
                            drMetrics.cif.METRIC_TYPE_ID = 'Actual'
                            drMetrics.cif.REFERENCE_ID = anEPG.cif.WB_EVTPG_ID
                            drMetrics.cif.REFERENCE_ID_UI = self.WB_Event.cif.EVENT_ID + '-' + anEPG.cif.WB_PRDGRP_ID
                            self.dbContext.add(esWB_Metric, drMetrics);
                            anEPGO.WB_MetricRow_Actual = drMetrics;
                        }))
            }

            if (_.isEmpty(anEPGO.WB_MetricRow_ActualOvrd)) {
                tasks.push(
                    self.dbContext.createRecordWithKey(esWB_Metric)
                        .then((drMetrics: WB_MetricRow) => {
                            drMetrics.setDefaults()
                            drMetrics.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                            drMetrics.cif.WB_PLAN_ID = self.WB_Event.cif.WB_PLAN_ID
                            drMetrics.cif.WB_PRDGRP_ID = anEPG.cif.WB_PRDGRP_ID
                            drMetrics.cif.REFERENCE_LEVEL_ID = 'EventPG'
                            drMetrics.cif.METRIC_TYPE_ID = 'ActualOvrd'
                            drMetrics.cif.REFERENCE_ID = anEPG.cif.WB_EVTPG_ID
                            drMetrics.cif.REFERENCE_ID_UI = self.WB_Event.cif.EVENT_ID + '-' + anEPG.cif.WB_PRDGRP_ID
                            self.dbContext.add(esWB_Metric, drMetrics);
                            anEPGO.WB_MetricRow_ActualOvrd = drMetrics;
                        }))

            }

            if (_.isEmpty(anEPG.WB_MetricRow_Planned)) { // conditionally do it ?
                tasks.push(
                    self.dbContext.createRecordWithKey(esWB_Metric)
                        .then((aMetricRow: WB_MetricRow) => {
                            aMetricRow.setDefaults()
                            aMetricRow.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID
                            aMetricRow.cif.WB_PLAN_ID = self.drWB_Event.cif.WB_PLAN_ID
                            aMetricRow.cif.WB_PRDGRP_ID = anEPG.cif.WB_PRDGRP_ID
                            aMetricRow.cif.REFERENCE_LEVEL_ID = 'EventPG'
                            aMetricRow.cif.METRIC_TYPE_ID = "Plan"
                            aMetricRow.cif.REFERENCE_ID = anEPG.cif.WB_EVTPG_ID
                            aMetricRow.cif.REFERENCE_ID_UI = self.drWB_Event.cif.EVENT_ID + "-" + anEPG.cif.WB_PRDGRP_ID
                            aMetricRow.cif.REFERENCE_LEVEL_ID = "EventPG"
                            self.dbContext.add(esWB_Metric, aMetricRow)
                            anEPG.WB_MetricRow_Planned = aMetricRow
                        })
                )
            }

            return Promise.all(tasks)
                .then((ignore) => {

                    // Wire up Change Events
                    anEventPGRow.setupOnChangeEvents([], self.IEventProductGroup_onRecordChange.bind(self), self)
                    if (!_.isEmpty(anEventPGRow.WB_EventProductGroupOverrideRow)) {
                        anEventPGRow.WB_EventProductGroupOverrideRow.setupOnChangeEvents([], self.IEventProductGroupOverride_onRecordChange.bind(self), {
                            EventBO: self,
                            Row: anEventPGRow
                        })
                    }

                    resolve()
                }).catch((err) => {
                    error(err)
                })
        })

    }

    private _EventSourceCustomerRow_AfterCreate(anEventSCRow: WB_EventCustomerRow): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            // Synchronous part
            // Wire up Change Events
            anEventSCRow.setupOnChangeEvents([], self.IEventSourceCustomer_onRecordChange.bind(self), self)

            // Async part(s)
            // none

            resolve()

        });

    }

    private _EventSpendProductGroupRow_AfterCreate(anEventSPGRow: WB_EventSpendPrdGrpRow): Promise<void> {
        const self = this
        const espg = anEventSPGRow

        return new Promise<void>((resolve, error) => {

            let espgo: WB_EventSpendPrdGrpOverrideRow
            let bOvrdRowCreatedNew = false

            if (!_.isEmpty(espg.WB_EventSpendPrdGrpOverrideRow)) {
                espgo = espg.WB_EventSpendPrdGrpOverrideRow
            } else {
                espgo = <any>self.dbContext.createRecord(esWB_Event_Spend_PrdGrp_Override)
                espgo.setDefaults()
                bOvrdRowCreatedNew = true
                espgo.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                espgo.cif.WB_EVTSPG_ID = espg.cif.WB_EVTSPG_ID
                espgo.cif.WB_PRDGRP_ID = espg.cif.WB_PRDGRP_ID

                self.dbContext.add(esWB_Event_Spend_PrdGrp_Override, espgo)
                espg.WB_EventSpendPrdGrpOverrideRow = espgo
            }


            let tasks: Promise<any>[] = []

            // async initialize SPG record
            if (bOvrdRowCreatedNew) {
                tasks.push(espgo.defaultSpendCalcMethod(anEventSPGRow))
            }

            // create Missing Metrics Records

            if (_.isEmpty(espgo.WB_MetricRow_Actual)) {
                tasks.push(
                    self.dbContext.createRecordWithKey(esWB_Metric)
                        .then((drMetrics: WB_MetricRow) => {
                            drMetrics.setDefaults()
                            drMetrics.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                            drMetrics.cif.WB_PLAN_ID = self.WB_Event.cif.WB_PLAN_ID
                            drMetrics.cif.REFERENCE_LEVEL_ID = 'EventSPG'
                            drMetrics.cif.METRIC_TYPE_ID = 'Actual'
                            drMetrics.cif.REFERENCE_ID = espg.cif.WB_EVTSPG_ID
                            drMetrics.cif.REFERENCE_ID_UI = self.WB_Event.cif.EVENT_ID + '-S-' + espg.cif.WB_PRDGRP_ID
                            drMetrics.cif.WB_PRDGRP_ID = espg.cif.WB_PRDGRP_ID;
                            self.dbContext.add(esWB_Metric, drMetrics);
                            espgo.WB_MetricRow_Actual = drMetrics;
                        }))
            }

            if (_.isEmpty(espgo.WB_MetricRow_ActualOvrd)) {
                tasks.push(
                    self.dbContext.createRecordWithKey(esWB_Metric)
                        .then((drMetrics: WB_MetricRow) => {
                            drMetrics.setDefaults()
                            drMetrics.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                            drMetrics.cif.WB_PLAN_ID = self.WB_Event.cif.WB_PLAN_ID
                            drMetrics.cif.REFERENCE_LEVEL_ID = 'EventSPG'
                            drMetrics.cif.METRIC_TYPE_ID = 'ActualOvrd'
                            drMetrics.cif.REFERENCE_ID = espg.cif.WB_EVTSPG_ID
                            drMetrics.cif.REFERENCE_ID_UI = self.WB_Event.cif.EVENT_ID + '-S-' + espg.cif.WB_PRDGRP_ID
                            drMetrics.cif.WB_PRDGRP_ID = espg.cif.WB_PRDGRP_ID;
                            self.dbContext.add(esWB_Metric, drMetrics);
                            espgo.WB_MetricRow_ActualOvrd = drMetrics;
                        }))
            }

            Promise.all(tasks)
                .then((ignore) => {

                    // Wire up Events
                    if (anEventSPGRow.WB_EventSpendPrdGrpOverrideRow) {
                        anEventSPGRow.WB_EventSpendPrdGrpOverrideRow.setupOnChangeEvents([], self.IEventSpendProductGroupOverride_onRecordChange.bind(self), {
                            EventBO: self,
                            Row: anEventSPGRow
                        })
                    }

                    resolve()
                }).catch((err) => {
                error(err)
            })
        })

    }

    private _EventRedistribSpendProductGroupRow_AfterCreate(anEventRSPGRow: WB_EventSpendPrdGrpRedistribRow): Promise<void> {
        const self = this
        const erspg = anEventRSPGRow

        return new Promise<void>((resolve, error) => {


            // Add overlapping metric Row if missing
            let bMissingMetricsRow = _.isEmpty(anEventRSPGRow.WB_MetricRow_Overlap)
            let createPromise: Promise<any> = undefined

            if (bMissingMetricsRow) {
                createPromise = self.dbContext.createRecordWithKey(esWB_Metric)
            } else {
                createPromise = ASync.resolve(anEventRSPGRow.WB_MetricRow_Overlap)
            }

            createPromise
                .then((aMetricRow: WB_MetricRow) => {

                    if (bMissingMetricsRow) {
                        aMetricRow.setDefaults()
                        aMetricRow.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID
                        aMetricRow.cif.WB_PLAN_ID = self.drWB_Event.cif.WB_PLAN_ID
                        aMetricRow.cif.WB_PRDGRP_ID = anEventRSPGRow.cif.WB_PRDGRP_ID
                        aMetricRow.cif.REFERENCE_LEVEL_ID = 'EventRSPG'
                        aMetricRow.cif.METRIC_TYPE_ID = "Overlap"
                        aMetricRow.cif.REFERENCE_ID = anEventRSPGRow.cif.WB_EVTRSPG_ID
                        aMetricRow.cif.REFERENCE_ID_UI = self.drWB_Event.cif.EVENT_ID + "-" + anEventRSPGRow.cif.WB_EVTRSPG_ID
                        anEventRSPGRow.cif.WB_METRIC_ID_OVRLP = aMetricRow.cif.WB_METRIC_ID
                        self.dbContext.add(esWB_Metric, aMetricRow)
                        anEventRSPGRow.WB_MetricRow_Overlap = aMetricRow
                    }

                    // Sync part..
                    anEventRSPGRow.setupOnChangeEvents([], self.IEventRedistributed_onRecordChange.bind(self), self)

                    let espg = anEventRSPGRow.WB_EventSpendPrdGrpRow
                    if (espg) {
                        let espgo = espg.WB_EventSpendPrdGrpOverrideRow
                        if (espgo) {
                            let espgomtrc = espgo.WB_MetricRow_ActualOvrd
                            if (espgomtrc) {
                                //espgomtrc.cif.SPEND_TOTAL
                                espgomtrc.setupOnChangeEvents(['SPEND_TOTAL'], self.IEventRedistributedSpendProductGroupMetrics_onRecordChange.bind(self), {
                                    EventBO: self,
                                    Row: erspg
                                })
                            }
                        }
                    }

                    resolve()

                }).catch((err) => {
                error(err)
            })
        })

    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options: any): Promise<IBusinessObject> {

        const self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.Identity.name + "(" + self.Identity.id_ui + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {

            options = options || {}
            _.defaultsDeep(options, EventSaveValidateOptions_default)
            self.ValidateOptions = options;

            if (_.isEmpty(self.dbContext)) {
                var sError = "Unable to determine dbContext to Validate Event.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
                return
            }


            // TODO: Add real validations here.

            // Things to validate:
            // 1. Date overrides
            // 2. Volume overrides
            // 3. Base Price Override?
            // 4. Spend Row Errors..
            // 5. Tag Validation/ Policy Enforcement
            // 6.


            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });

    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: IEventSaveValidateOptions): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: IEventSaveValidateOptions): Promise<IBusinessObject> {

        const self = this;
        this.SaveProgressProvider.start("Saving " + this.Identity.name + "(" + this.Identity.id_ui + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {

            if (!PAEnvironment.isNode()) {
                if (self.EditorLock.Status === "ReadOnly") {
                    self._bIsSaved = false;
                    var sError = "Unable to Save Locked Event.";
                    self.SaveProgressProvider.exception(sError);
                    reject(sError);
                    return
                }
            }

            if (_.isEmpty(self.dbContext)) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Event.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            options = options || {}
            _.defaultsDeep(options, EventSaveValidateOptions_default)
            self.SaveOptions = options;

            var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            ASync.resolve()
                .then((ignored) => {
                    self.SaveProgressProvider.setPercentComplete(0.1)
                    if (options.Validate.bSkipAllValidations) {
                        return ASync.resolve()
                    } else {
                        return self.Validate(options)
                        // Run Validate
                    }
                })
                .then(() => {
                    return self.updateEventCirculars()
                })
                .then(() => {
                    // Check Validate Success..
                    self.SaveProgressProvider.setPercentComplete(0.5)
                    var tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_Event, self.drWB_Event))
                    tasks.push(saveFunction(esWB_Event_Override, self.drWB_Event.WB_EventOverrideRow))
                    tasks.push(saveFunction(esWB_Event_Product_Group, self.drWB_Event.WB_Event_ProductGroupRows))
                    tasks.push(saveFunction(esWB_Event_Spend_PrdGrp, self.drWB_Event.WB_EventSpend_ProductGroupRows))
                    tasks.push(saveFunction(esWB_Event_Spend_PrdGrp_Redistrib, self.drWB_Event.WB_EventSpend_RedistributionRows))
                    tasks.push(saveFunction(esWB_Event_Tag, self.drWB_Event.WB_Event_TagRows))
                    tasks.push(saveFunction(esWB_Event_Meta, self.drWB_Event.WB_Event_MetaRows))
                    tasks.push(saveFunction(esWB_Event_Customer, self.drWB_Event.WB_Event_SourceCustomerRows))
                    tasks.push(saveFunction(esWB_Event_Relationship, self.drWB_Event.WB_EventRelationshipRow_Source))
                    tasks.push(saveFunction(esWB_Event_Relationship, self.drWB_Event.WB_EventRelationshipRow_Target))
                    tasks.push(saveFunction(esWB_EventFR, self.drWB_Event.WB_EventFinanceRelationshipRows))
                    tasks.push(saveFunction(esWB_Event_Circular, self.drWB_Event.WB_EventCircularRows))
                    tasks.push(saveFunction(esWB_EvtShipPrd, self.drWB_Event.WB_EvtShipPrdRows))
                    tasks.push(saveFunction(esWB_EvtSShpPrd, self.drWB_Event.WB_EvtSShpPrdRows))

                    const arrEventProducts: WB_EventProductRow[]
                        = _.flatMap(self.drWB_Event.WB_Event_ProductGroupRows, function (aEventPGRow: WB_EventProductGroupRow) {
                        return aEventPGRow.WB_EventProductRows;
                    });
                    tasks.push(saveFunction(esWB_Event_Product, arrEventProducts))

                    const arrEventSpendProducts: WB_EventSpendPrdRow[]
                        = _.flatMap(self.drWB_Event.WB_EventSpend_ProductGroupRows, function (aEventSPGRow: WB_EventSpendPrdGrpRow) {
                        return aEventSPGRow.WB_EventSpendPrdRows;
                    });
                    tasks.push(saveFunction(esWB_Event_Spend_Prd, arrEventSpendProducts))

                    const arrEventSpendCustomers: WB_EventSpendPrdGrpCustomerRow[]
                        = _.flatMap(self.drWB_Event.WB_EventSpend_ProductGroupRows, function (aEventSPGRow: WB_EventSpendPrdGrpRow) {
                        return aEventSPGRow.WB_EventSpendPrdGrpCustomerRows;
                    });
                    tasks.push(saveFunction(esWB_Event_Spend_PrdGrp_Customer, arrEventSpendCustomers))

                    const arrEvtShipCProd: WB_EvtShipCPrdRow[] = []
                    _.forEach(self.drWB_Event.WB_EvtShipPrdRows, (aRow) => {

                        _.forEach(aRow.WB_EvtShipCPrdRows, (r) => {
                            arrEvtShipCProd.push(r)
                        })

                    })
                    tasks.push(saveFunction(esWB_EvtShipCPrd, arrEvtShipCProd))

                    const arrEvtShipProdO: WB_EvtSShpPrdOverrideRow[] = []

                    const arrMetrics: WB_MetricRow[] = []
                    const arrPGOvrd: WB_EventProductGroupOverrideRow[] = []
                    const arrSPGOvrd: WB_EventSpendPrdGrpOverrideRow[] = []

                    if (self.drWB_Event.WB_EventOverrideRow) {
                        if (self.drWB_Event.WB_EventOverrideRow.WB_MetricRow_Actual) {
                            arrMetrics.push(self.drWB_Event.WB_EventOverrideRow.WB_MetricRow_Actual)
                        }
                        if (self.drWB_Event.WB_EventOverrideRow.WB_MetricRow_ActualOvrd) {
                            arrMetrics.push(self.drWB_Event.WB_EventOverrideRow.WB_MetricRow_ActualOvrd)
                        }
                    }

                    _.forEach(self.drWB_Event.WB_Event_ProductGroupRows, (epg: WB_EventProductGroupRow) => {
                        if (epg.WB_EventProductGroupOverrideRow) {
                            arrPGOvrd.push(epg.WB_EventProductGroupOverrideRow)

                            if (epg.WB_EventProductGroupOverrideRow.WB_MetricRow_Actual) {
                                arrMetrics.push(epg.WB_EventProductGroupOverrideRow.WB_MetricRow_Actual)
                            }
                            if (epg.WB_EventProductGroupOverrideRow.WB_MetricRow_ActualOvrd) {
                                arrMetrics.push(epg.WB_EventProductGroupOverrideRow.WB_MetricRow_ActualOvrd)
                            }
                        }

                        if (epg.WB_MetricRow_Planned) {
                            arrMetrics.push(epg.WB_MetricRow_Planned)
                        }
                    })

                    _.forEach(self.drWB_Event.WB_EvtSShpPrdRows, (aRow: WB_EvtSShpPrdRow) => {
                        if (aRow?.WB_EvtSShpPrdOverrideRow) {
                            arrEvtShipProdO.push(aRow.WB_EvtSShpPrdOverrideRow)

                            if (aRow?.WB_EvtSShpPrdOverrideRow?.WB_MetricRow_Actual) {
                                arrMetrics.push(aRow.WB_EvtSShpPrdOverrideRow.WB_MetricRow_Actual)
                            }
                            if (aRow?.WB_EvtSShpPrdOverrideRow?.WB_MetricRow_ActualOvrd) {
                                arrMetrics.push(aRow.WB_EvtSShpPrdOverrideRow.WB_MetricRow_ActualOvrd)
                            }
                        }
                    })
                    tasks.push(saveFunction(esWB_EvtSShpPrdO, arrEvtShipProdO))

                    _.forEach(self.drWB_Event.WB_EventSpend_ProductGroupRows, (espg: WB_EventSpendPrdGrpRow) => {

                        if (espg.WB_EventSpendPrdGrpOverrideRow) {
                            arrSPGOvrd.push(espg.WB_EventSpendPrdGrpOverrideRow)
                            if (espg.WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_Actual) {
                                arrMetrics.push(espg.WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_Actual)
                            }
                            if (espg.WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_ActualOvrd) {
                                arrMetrics.push(espg.WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_ActualOvrd)
                            }
                        }
                    })

                    _.forEach(self.drWB_Event.WB_EventSpend_RedistributionRows, (erspg: WB_EventSpendPrdGrpRedistribRow) => {
                        arrMetrics.push(erspg.WB_MetricRow_Overlap)
                    })

                    if (!_.isEmpty(self.drWB_Event.WB_EventOverrideRow) && !_.isEmpty(self.drWB_Event.WB_EventOverrideRow.WB_MetricRow_Funding))
                        arrMetrics.push(self.drWB_Event.WB_EventOverrideRow.WB_MetricRow_Funding)

                    _.forEach(self.WB_Event.WB_EventFinanceRelationshipRows, aRow => {
                        if (aRow.isActive && !_.isEmpty(aRow.WB_MetricRow_Funding))
                            arrMetrics.push(aRow.WB_MetricRow_Funding)
                    })

                    tasks.push(saveFunction(esWB_Metric, arrMetrics))
                    tasks.push(saveFunction(esWB_Event_Product_Group_Override, arrPGOvrd))
                    tasks.push(saveFunction(esWB_Event_Spend_PrdGrp_Override, arrSPGOvrd))

                    return Promise.all(tasks)

                }).then((ignored) => {

                if (bBatch) {
                    self.dbContext.addBatchCompleteListener(() => {
                        self._bIsSaved = true;
                    })
                } else {
                    self._bIsSaved = true;
                }
                self.SaveProgressProvider.finish();
                resolve(self);

            }).catch((err) => {
                self.SaveProgressProvider.exception(err);
                resolve(self)
            })
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    Delete(): Promise<IBusinessObject> {
        return this.DeleteUsing(false)
    }

    DeleteBatch(): Promise<IBusinessObject> {
        return this.DeleteUsing(true)
    }

    private DeleteRows(): void {
        let self = this

        self.WB_Event.markDeleted()
        if (self.WB_Event.WB_EventOverrideRow) {

            if (self.WB_Event.WB_EventOverrideRow.WB_MetricRow_Actual) {
                self.WB_Event.WB_EventOverrideRow.WB_MetricRow_Actual.markDeleted()
            }

            if (self.WB_Event.WB_EventOverrideRow.WB_MetricRow_ActualOvrd) {
                self.WB_Event.WB_EventOverrideRow.WB_MetricRow_ActualOvrd.markDeleted()
            }

            self.WB_Event.WB_EventOverrideRow.markDeleted()
        }


        _.forEach(self.WB_Event.WB_Event_SourceCustomerRows, (esc: WB_EventCustomerRow) => {
            if (esc.isActive) {
                esc.markDeleted()
            }
        })

        _.forEach(self.WB_Event.WB_Event_ProductGroupRows, (epg: WB_EventProductGroupRow) => {
            if (epg.isActive) {
                epg.markDeleted()

                _.forEach(epg.WB_EventProductRows, (eprd: WB_EventProductRow) => {
                    if (eprd.isActive) {
                        eprd.markDeleted()
                    }
                })

                if (epg.WB_EventProductGroupOverrideRow) {

                    if (epg.WB_EventProductGroupOverrideRow.WB_MetricRow_Actual) {
                        epg.WB_EventProductGroupOverrideRow.WB_MetricRow_Actual.markDeleted()
                    }

                    if (epg.WB_EventProductGroupOverrideRow.WB_MetricRow_ActualOvrd) {
                        epg.WB_EventProductGroupOverrideRow.WB_MetricRow_ActualOvrd.markDeleted()
                    }

                    epg.WB_EventProductGroupOverrideRow.markDeleted()
                }

            }
        })

        _.forEach(self.WB_Event.WB_EventSpend_ProductGroupRows, (espg: WB_EventSpendPrdGrpRow) => {

            if (espg.isActive) {

                _.forEach(espg.WB_EventSpendPrdRows, (esprd: WB_EventSpendPrdRow) => {
                    if (esprd.isActive) {
                        esprd.markDeleted()
                    }
                })

                _.forEach(espg.WB_EventSpendPrdGrpCustomerRows, (escst: WB_EventSpendPrdGrpCustomerRow) => {
                    if (escst.isActive) {
                        escst.markDeleted()
                    }
                })

                if (espg.WB_EventSpendPrdGrpOverrideRow) {

                    if (espg.WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_Actual) {
                        espg.WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_Actual.markDeleted()
                    }

                    if (espg.WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_ActualOvrd) {
                        espg.WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_ActualOvrd.markDeleted()
                    }

                    espg.WB_EventSpendPrdGrpOverrideRow.markDeleted()
                }

                espg.markDeleted()
            }

        })

        _.forEach(self.WB_Event.WB_EventSpend_RedistributionRows, (erspg: WB_EventSpendPrdGrpRedistribRow) => {
            if (erspg.isActive) {
                erspg.markDeleted()

                if (erspg.WB_MetricRow_Overlap) {
                    erspg.WB_MetricRow_Overlap.markDeleted()
                }
            }
        })

        _.forEach(self.WB_Event.WB_Event_MetaRows, (em: WB_EventMetaRow) => {
            if (em.isActive) {
                em.markDeleted()
            }
        })


    }

    private DeleteUsing(bBatch: boolean): Promise<IBusinessObject> {
        const self = this;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + self.Identity.name + "(" + self.Identity.id_ui + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // 1. Validate if we can delete the event


            // 2. Do the Delete
            self.DeleteRows();
            self.SaveUsing(bBatch)
            self._bIsDeleted = true;
            self.DeleteProgressProvider.finish();
            resolve(self);
        });

    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }


    //</editor-fold>

    //<editor-fold desc = "IBusinessObject optional operations">


    Copy(options?: IEventCopyOptions): Promise<IBusinessObject> {
        const self = this

        const copyOptions: IEventCopyOptions = options || {}
        _.defaults(copyOptions, EventCopyOptions_default)

        const srcEvent: EventBO = this;

        let bUsePlanProducts = false
        if (_.isBoolean(copyOptions.bUsePlanProducts))
            bUsePlanProducts = copyOptions.bUsePlanProducts

        return new Promise<EventBO>((resolve, error) => {

            // Load the Plan
            let tgtEvent: EventBO = undefined
            srcEvent.OnIHavePlanLoaded
                .then((ignore) => {

                    tgtEvent = new EventBO({Plan: srcEvent.Plan});
                    return tgtEvent.LoadNew()

                }).then((ignore) => {

                if (!tgtEvent.bIsLoaded) {
                    error(tgtEvent.LoadProgressProvider.process_exception)
                    return
                }

                async function copySequential() {

                    // Sync top level, except create key

                    RecordUtils.CopyProperties(tgtEvent.dbContext, esWB_Event, srcEvent.WB_Event, tgtEvent.WB_Event,
                        [],
                        ['WB_PLAN_ID', 'EVENT_ID', 'EVENT_ROW_ID', 'PLANNING_PROFILE_GROUP_ID', 'MANUAL_IND', 'WB_CUST_ID_PLANNING', 'WB_CUST_ID_SUBPLANNING', 'SOURCE_ID', 'INTEGRATION_IND', 'DELETED_DT', 'DELETED_IND'],
                        {})


                    // Add each Source Customer
                    let srcCustomers = srcEvent.SourceCustomers
                    if (copyOptions.bIncludeEventSubCustomers && srcCustomers.length > 0) {
                        for (let idx = 0; idx < srcCustomers.length; idx++) {
                            let srcCustomer = srcCustomers[idx]
                            await tgtEvent.addEventSourceCustomer(srcCustomer.cif.WB_CUST_ID, {})
                        }
                    }

                    // Add each Product Group
                    let dctProductsBywbPGId: { [wbPrdGrpId: number]: number[] } = {}
                    if (!bUsePlanProducts) {
                        _.forEach(srcEvent.WB_Event.WB_Event_ProductGroupRows, (aPGRow) => {
                            if (!aPGRow.isActive) {
                                return
                            }

                            let arrWbProdIds: number[] = []
                            _.forEach(aPGRow.WB_EventProductRows, (aRow) => {
                                if (aRow.isActive && aRow.WB_FinishedProductRow) {
                                    arrWbProdIds.push(aRow.cif.WB_PROD_ID)
                                }
                            })
                            dctProductsBywbPGId[aPGRow.cif.WB_PRDGRP_ID] = arrWbProdIds
                        })
                    }
                    let srcProductGroups = srcEvent.ProductGroups
                    if (copyOptions.bIncludeEventProductGroups) {
                        for (let idx = 0; idx < srcProductGroups.length; idx++) {
                            let srcPrdGrp = srcProductGroups[idx]
                            let addOpts: IEventProductGroupAddOptions = {}
                            if ((!bUsePlanProducts) && (srcPrdGrp.cif.WB_PRDGRP_ID in dctProductsBywbPGId)) {
                                addOpts.FinishedProductsIds = dctProductsBywbPGId[srcPrdGrp.cif.WB_PRDGRP_ID]
                            }
                            await tgtEvent.addEventProductGroup(srcPrdGrp.cif.WB_PRDGRP_ID, addOpts)
                        }
                    }

                    // Add each Spend Product Group

                    // Add each Redestributed Spend

                    // Add each Tag
                    let srcTags = srcEvent.Tags
                    if (copyOptions.bIncludeEventTags) {
                        for (let idx = 0; idx < srcTags.length; idx++) {
                            let srcTag = srcTags[idx]
                            await tgtEvent.addTag(srcTag.cif.WB_TAG_ID)
                        }
                    }

                    // Add each Meta

                    resolve(tgtEvent)
                }

                copySequential()

            }).catch((err) => {
                error(err)
            })

        })


    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        const self = this
        this.DeleteOptions = options || {}
        this.DeleteRows()
        this._bIsDeleted = true
        this._bDeleteOnSave = true
        this.SourceCustomersChanged.next(self)
        this.ProductGroupsChanged.next(self)
        this.ExecutionBoundsChanged.next(self)
        this.SpendCollectionChanged.next(self)
        this.RedistributedSpendCollectionChanged.next(self)
        this.Save()
        return ASync.resolve(self)
    }

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}
        /*
            opts.dctIgnoreChanges = opts.dctIgnoreChanges || {}
            opts.dctIgnoreChanges[esWB_Event_Override] = {bNew: true}
            opts.dctIgnoreChanges[esWB_Event_Product_Group_Override] = {bNew: true}
            opts.dctIgnoreChanges[esWB_Event_Spend_PrdGrp_Override]= {bNew: true}
        */
        // -- Override records have HasOne relationships, so the changes will be detected
        // -- WB_Metrics have Belongs to relationships, so they will be ignored.

        // Set any BO Specific change settings
        return DefaultChanges(this, this.drWB_Event, opts)
    }

//</editor-fold>


    //<editor-fold desc = "IEvent operations">

    private _EventPropertyChanged: BehaviorSubject<IEventChangedEvent>;

    private IEvent_init(): void {
        this._EventPropertyChanged = new BehaviorSubject<IEventChangedEvent>(undefined)
    }

    private IEvent_onRecordChange(record: WB_EventRow, propertyName: string, propertyValue: any, options: EventBO) {
        this.EventPropertyChanged.next({
            EventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    private IEventOverride_onRecordChange(record: WB_EventOverrideRow, propertyName: string, propertyValue: any, options: EventBO) {
        this.EventPropertyChanged.next({
            EventBO: options,
            Row: options.WB_Event,
            PropertyChanged: 'WB_EventOverrideRow.' + propertyName,
            PropertyValue: propertyValue
        })
    }

    get EventPropertyChanged(): BehaviorSubject<IEventChangedEvent> {
        return this._EventPropertyChanged
    }

    //</editor-fold>

    //<editor-fold desc = "IEventProductGroup operations">


    private _ProductGroupPropertyChanged: BehaviorSubject<IEventProductGroupChangedEvent>;
    private _ProductGroupCollectionChanged: BehaviorSubject<EventBO>;

    private IEventProductGroup_init(): void {
        this._ProductGroupPropertyChanged = new BehaviorSubject<IEventProductGroupChangedEvent>(undefined)
        this._ProductGroupCollectionChanged = new BehaviorSubject<EventBO>(this);
    }

    private IEventProductGroup_onRecordChange(record: WB_EventProductGroupRow, propertyName: string, propertyValue: any, options: EventBO) {
        this.ProductGroupPropertyChanged.next({
            EventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    private IEventProductGroupOverride_onRecordChange(record: WB_EventProductGroupOverrideRow, propertyName: string, propertyValue: any, options: { EventBO: EventBO, Row: WB_EventProductGroupRow }) {
        this.ProductGroupPropertyChanged.next({
            EventBO: options.EventBO,
            Row: options.Row,
            PropertyChanged: 'WB_EventProductGroupOverrideRow.' + propertyName,
            PropertyValue: propertyValue
        })
    }

    async addEventProductGroup(WB_PrdGrp_ID: number, options: IEventProductGroupAddOptions): Promise<EventBO> {
        const self = this
        const opts = options || {}

        let found = false
        _.forEach(self.drWB_Event.WB_Event_ProductGroupRows, (epg: WB_EventProductGroupRow) => {
            if (epg && epg.isActive && !_.isEmpty(epg.WB_ProductGroupRow)) {
                if (epg.WB_ProductGroupRow.cif.WB_PRDGRP_ID == WB_PrdGrp_ID) {
                    found = true
                    return false // stop iterating
                }
            }
        })

        if (found) {
            return (self)
        }

        let aPGRow: WB_ProductGroupRow = undefined
        //let aEPGRow: WB_EventProductGroupRow = undefined

        let aWB_ProductGroupRow: WB_ProductGroupRow = await self.dbContext.find(esWB_Product_Group, WB_PrdGrp_ID)
        if (_.isEmpty(aWB_ProductGroupRow)) {
            throw("Unable to locate Product Group with ID: " + WB_PrdGrp_ID)
            return
        }
        aPGRow = aWB_ProductGroupRow

        let aWB_EventPGRow: WB_EventProductGroupRow = <WB_EventProductGroupRow>await self.dbContext.createRecordWithKey(esWB_Event_Product_Group);

        if (_.isEmpty(aWB_EventPGRow)) {
            throw("Unable to create Event PG Row")
            return
        }

        aWB_EventPGRow.setDefaults()
        aWB_EventPGRow.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID
        // TOOD : Add? WB_Event row ?
        aWB_EventPGRow.cif.WB_PRDGRP_ID = aPGRow.cif.WB_PRDGRP_ID
        aWB_EventPGRow.WB_ProductGroupRow = aPGRow
        aWB_EventPGRow.cif.MANUAL_IND = '1'
        aWB_EventPGRow.cif.PG_DECOMP_METHOD = 'Standard'
        self.dbContext.add(esWB_Event_Product_Group, aWB_EventPGRow)

        await self._EventProductGroupRow_AfterCreate(aWB_EventPGRow)

        let arrFinishedProductsId: number[] = []
        if (_.isArray(opts.FinishedProductsIds)) {
            arrFinishedProductsId = opts.FinishedProductsIds
        } else {
            arrFinishedProductsId = await self.getProductGroupFinishedProducts(aPGRow.cif.WB_PRDGRP_ID, {})
        }

        await self.syncEventProductGroupFinishedProducts(aWB_EventPGRow, arrFinishedProductsId, true, false)

        self._dctIHaveProductGroups_reset()

        self._notifyEventProductGroupChanged()

    }

    removeEventProductGroup(WB_PrdGrp_ID: number): Promise<EventBO> {
        const self = this

        return new Promise<EventBO>((resolve, error) => {

            _.forEach(this.drWB_Event.WB_Event_ProductGroupRows, (epg: WB_EventProductGroupRow) => {
                if (epg && epg.isActive && !_.isEmpty(epg.WB_ProductGroupRow)) {
                    if ((epg.WB_ProductGroupRow.cif.WB_PRDGRP_ID == WB_PrdGrp_ID)
                        && (epg.cif.MANUAL_IND == '1')) {
                        epg.markDeleted()
                        if (epg.WB_EventProductGroupOverrideRow) {
                            epg.WB_EventProductGroupOverrideRow.markDeleted()
                            if (epg.WB_EventProductGroupOverrideRow.WB_MetricRow_Actual) {
                                epg.WB_EventProductGroupOverrideRow.WB_MetricRow_Actual.markDeleted()
                            }
                            if (epg.WB_EventProductGroupOverrideRow.WB_MetricRow_ActualOvrd) {
                                epg.WB_EventProductGroupOverrideRow.WB_MetricRow_ActualOvrd.markDeleted()
                            }
                        }

                        _.forEach(epg.WB_EventProductRows, (aRow) => {
                            aRow.markDeleted()
                        })

                        _.forEach(_.filter(self.drWB_Event.WB_EventSpend_RedistributionRows, aRow => aRow.cif.WB_PRDGRP_ID === epg.cif.WB_PRDGRP_ID), (aRow: WB_EventSpendPrdGrpRedistribRow) => {
                            self.removeEventRedistributedSpend(aRow.cif.WB_EVTRSPG_ID)
                        })

                        _.forEach(_.filter(self.drWB_Event.WB_EventSpend_ProductGroupRows, aRow => aRow.cif.WB_PRDGRP_ID === epg.cif.WB_PRDGRP_ID && aRow.cif.MANUAL_IND == '1'), (aRow: WB_EventSpendPrdGrpRow) => {
                            self.removeEventSpend(aRow.cif.WB_EVTSPG_ID)
                        })
                    }
                }
            })

            self._dctIHaveProductGroups_reset()

            self._notifyEventProductGroupChanged()

            resolve(self)
        })


    }

    private syncEventProductGroupFinishedProducts(aWB_EventPG: WB_EventProductGroupRow, arrFinishedProductIds: number[], bAddOnly: boolean = true, bNotifyChange: boolean = false): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.dbContext.findUsingCache(esWB_Finished_Product, arrFinishedProductIds)
                .then((arrFPs: WB_FinishedProductRow[]) => {
                    if (_.isEmpty(arrFPs)) {
                        resolve()
                        return
                    }
                    let dctRowByFinishedProduct = _.keyBy(_.filter(aWB_EventPG.WB_EventProductRows, 'isActive'), (aRow) => {
                        return aRow.cif.WB_PROD_ID
                    })
                    let dctRowsToDelete = _.clone(dctRowByFinishedProduct)

                    async function syncProducts() {
                        //
                        for (let idx = 0; idx < arrFPs.length; idx++) {
                            let fpRow = arrFPs[idx]
                            if (!(fpRow.cif.WB_PROD_ID in dctRowByFinishedProduct)) {
                                let anEventProductRow: WB_EventProductRow = <any>await self.dbContext.createRecordWithKey(esWB_Event_Product)
                                anEventProductRow.setDefaults()
                                anEventProductRow.cif.WB_EVT_ID = aWB_EventPG.cif.WB_EVT_ID
                                anEventProductRow.cif.WB_EVTPG_ID = aWB_EventPG.cif.WB_EVTPG_ID
                                anEventProductRow.cif.WB_PROD_ID = fpRow.cif.WB_PROD_ID
                                anEventProductRow.WB_FinishedProductRow = fpRow
                                self.dbContext.add(esWB_Event_Product, anEventProductRow)
                                delete dctRowsToDelete[fpRow.cif.WB_PROD_ID]
                            }
                        }

                        if (!bAddOnly) {
                            _.forEach(dctRowsToDelete, (value: WB_EventProductRow, key) => {
                                if (value.cif.MANUAL_IND == '1') {
                                    value.markDeleted()
                                }
                            })
                        }

                        if (bNotifyChange) {
                            self._notifyEventProductGroupChanged()
                        }

                        resolve()
                    }

                    syncProducts()

                }).catch((err) => {
                error(err)
            })
        })
    }

    private getProductGroupFinishedProducts(aWB_PrdGrp_ID: number, options?: any): Promise<number[]> {
        const self = this
        return new Promise<number[]>((resolve, error) => {
            self.OnIHavePlanLoaded
                .then((ignore) => {
                    if (!self.bIHavePlanLoaded) {
                        error("Unable to get Plan to determine Finished Products for Event")
                    }
                    //
                    _.forEach(self.Plan.WB_Plan.WB_Plan_ProductGroupRows, (aRow: WB_PlanProductGroupRow) => {
                        if (aRow && aRow.isActive && (aRow.cif.WB_PRDGRP_ID == aWB_PrdGrp_ID)) {
                            let returnValue: number[] = []
                            _.forEach(aRow.WB_PlanProductRows, (aPlanProductRow: WB_PlanProductRow) => {
                                returnValue.push(aPlanProductRow.cif.WB_PROD_ID)
                            })
                            resolve(returnValue)
                        }
                    })

                    resolve([])
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    get ProductGroupPropertyChanged(): BehaviorSubject<IEventProductGroupChangedEvent> {
        return this._ProductGroupPropertyChanged
    }

    get ProductGroupCollectionChanged(): BehaviorSubject<EventBO> {
        return this._ProductGroupCollectionChanged
    }

    private _notifyEventProductGroupChanged() {
        this.ProductGroupCollectionChanged.next(this)
        this.ProductGroupsChanged.next(this)

    }


//</editor-fold>

    //<editor-fold desc = "IEventSourceCustomer operations">

    private _SourceCustomerPropertyChanged: BehaviorSubject<IEventSourceCustomerChangedEvent>;
    private _SourceCustomerCollectionChanged: BehaviorSubject<EventBO>;

    private IEventSourceCustomer_init(): void {
        this._SourceCustomerPropertyChanged = new BehaviorSubject<IEventSourceCustomerChangedEvent>(undefined)
        this._SourceCustomerCollectionChanged = new BehaviorSubject<EventBO>(this)
    }

    private IEventSourceCustomer_onRecordChange(record: WB_EventCustomerRow, propertyName: string, propertyValue: any, options: any) {
        this.SourceCustomerPropertyChanged.next({
            EventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }


    addEventSourceCustomer(WB_Cust_ID: number, options: IEventSourceCustomerAddOptions): Promise<EventBO> {
        const self = this

        return new Promise<EventBO>((resolve, error) => {
            let found = false

            _.forEach(this.drWB_Event.WB_Event_SourceCustomerRows, (aSrcCustRelRow: WB_EventCustomerRow) => {
                if (aSrcCustRelRow.isActive && aSrcCustRelRow.WB_CustomerRow) {
                    if (aSrcCustRelRow.WB_CustomerRow.cif.WB_CUST_ID == WB_Cust_ID) {
                        found = true
                        return false
                    }
                }
            })

            if (found) {
                resolve(self)
                return
            }
            // Create New Record

            let aCustRow: WB_CustomerRow = undefined
            self.dbContext.find(esWB_Customer, WB_Cust_ID)
                .then((aWB_Customer: WB_CustomerRow) => {
                    if (_.isEmpty(aWB_Customer)) {
                        error("Unable to Find Customer with Id:" + WB_Cust_ID)
                        return
                    }
                    aCustRow = aWB_Customer
                    // create record
                    return self.dbContext.createRecordWithKey(esWB_Event_Customer)
                }).then((aWB_EventCustomerRow: WB_EventCustomerRow) => {

                aWB_EventCustomerRow.setDefaults()
                aWB_EventCustomerRow.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID
                aWB_EventCustomerRow.cif.WB_CUST_ID_SOURCE = aCustRow.cif.WB_CUST_ID
                aWB_EventCustomerRow.cif.MANUAL_IND = '1'
                self.dbContext.add(esWB_Event_Customer, aWB_EventCustomerRow)
                aWB_EventCustomerRow.WB_CustomerRow = aCustRow


                return self._EventSourceCustomerRow_AfterCreate(aWB_EventCustomerRow)
            }).then((ignore) => {

                self._notifyEventSourceCustomerChanged()
                resolve()

            }).catch((err) => {
                error(err)
            })

        });

    }

    removeEventSourceCustomer(WB_Cust_ID: number): Promise<EventBO> {
        const self = this

        return new Promise<EventBO>((resolve, error) => {

            let changed = false
            _.forEach(this.drWB_Event.WB_Event_SourceCustomerRows, (aSrcCustRelRow: WB_EventCustomerRow) => {
                if (aSrcCustRelRow.isActive && aSrcCustRelRow.WB_CustomerRow) {
                    if (aSrcCustRelRow.WB_CustomerRow.cif.WB_CUST_ID == WB_Cust_ID) {
                        aSrcCustRelRow.markDeleted()
                        changed = true
                    }
                }
            })

            if (changed) {
                self._notifyEventSourceCustomerChanged()
            }

            resolve(self)
        })

    }

    get SourceCustomerPropertyChanged(): BehaviorSubject<IEventSourceCustomerChangedEvent> {
        return this._SourceCustomerPropertyChanged
    }

    get SourceCustomerCollectionChanged(): BehaviorSubject<EventBO> {
        return this._SourceCustomerCollectionChanged
    }

    private _notifyEventSourceCustomerChanged() {
        this.SourceCustomerCollectionChanged.next(this)
        this.SourceCustomersChanged.next(this)
    }

//</editor-fold>

    //<editor-fold desc = "IEventSpend operations">

    private _SpendPropertyChanged: BehaviorSubject<IEventSpendChangedEvent>;
    private _SpendCollectionChanged: BehaviorSubject<EventBO>;

    private IEventSpend_init(): void {
        this._SpendPropertyChanged = new BehaviorSubject<IEventSpendChangedEvent>(undefined)
        this._SpendCollectionChanged = new BehaviorSubject<EventBO>(this)
    }

    private IEventSpendProductGroup_onRecordChange(record: WB_EventSpendPrdGrpRow, propertyName: string, propertyValue: any, options: EventBO) {
        this.SpendPropertyChanged.next({
            EventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    private IEventSpendProductGroupOverride_onRecordChange(record: WB_EventSpendPrdGrpOverrideRow, propertyName: string, propertyValue: any, options: { EventBO: EventBO, Row: WB_EventSpendPrdGrpRow }) {
        this.SpendPropertyChanged.next({
            EventBO: options.EventBO,
            Row: options.Row,
            PropertyChanged: 'WB_EventSpendPrdGrpOverrideRow.' + propertyName,
            PropertyValue: propertyValue
        })
    }

    addEventSpend(WB_PrdGrp_ID: number, options: IEventSpendAddOptions): Promise<EventBO> {
        const self = this
        let opts = options || {}

        return new Promise<EventBO>((resolve, error) => {

            let newPG: WB_ProductGroupRow = undefined
            let newESPG: WB_EventSpendPrdGrpRow = undefined
            self.dbContext.find(esWB_Product_Group, WB_PrdGrp_ID)
                .then((drWB_PrdGrp: WB_ProductGroupRow) => {

                    if (_.isEmpty(drWB_PrdGrp)) {
                        error("Unknown Product Group: " + WB_PrdGrp_ID)
                        return
                    }
                    newPG = drWB_PrdGrp

                    // Create new Record
                    return self.dbContext.createRecordWithKey(esWB_Event_Spend_PrdGrp)

                }).then((drEvtSPG: WB_EventSpendPrdGrpRow) => {

                newESPG = drEvtSPG
                // defaults are set with afterCreateRecordWithKey

                drEvtSPG.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                drEvtSPG.cif.WB_PRDGRP_ID = newPG.cif.WB_PRDGRP_ID
                drEvtSPG.WB_ProductGroupRow = newPG
                drEvtSPG.cif.DEAL_START_DT = self.WB_Event.cif.INSTORE_START_DT
                drEvtSPG.cif.DEAL_END_DT = self.WB_Event.cif.INSTORE_END_DT
                drEvtSPG.cif.INSTORE_START_DT = self.WB_Event.cif.INSTORE_START_DT
                drEvtSPG.cif.INSTORE_END_DT = self.WB_Event.cif.INSTORE_END_DT
                drEvtSPG.cif.SHIPMENT_START_DT = self.WB_Event.cif.SHIPMENT_START_DT
                drEvtSPG.cif.SHIPMENT_END_DT = self.WB_Event.cif.SHIPMENT_END_DT
                drEvtSPG.cif.REDEMPTION_PCNT = 1

                // Iterate over options to set defaults.
                if ('DealStartDt' in opts) {
                    if (_.isDate(opts.DealStartDt)) {
                        drEvtSPG.InStoreStartDt = opts.DealStartDt
                        drEvtSPG.ShipmentStartDt = opts.DealStartDt
                    }
                }

                if ('DealEndDt' in opts) {
                    if (_.isDate(opts.DealEndDt)) {
                        drEvtSPG.InStoreEndDt = opts.DealEndDt
                        drEvtSPG.ShipmentEndDt = opts.DealEndDt
                    }
                }

                if ('PaymentMethodId' in opts) {
                    drEvtSPG.cif.PAYMENT_METHOD_ID = opts.PaymentMethodId
                }

                if (_.isNumber(opts.RateAmt)) {
                    drEvtSPG.cif.RATE_AMT = opts.RateAmt
                }

                if (_.isNumber(opts.RateAmtPerUnit)) {
                    drEvtSPG.cif.RATE_AMT_PER_UNIT = opts.RateAmtPerUnit
                }

                if (!_.isEmpty(opts.RateBasisID)) {
                    drEvtSPG.cif.RATE_BASIS_ID = opts.RateBasisID
                }

                if (!_.isEmpty(opts.RateUOM)) {
                    drEvtSPG.cif.RATE_UOM = opts.RateUOM
                }

                if (_.isNumber(opts.WB_SpendM_Id)) {
                    drEvtSPG.cif.WB_SPENDM_ID = opts.WB_SpendM_Id
                }

                // Add Record to DataStore
                self.dbContext.add(esWB_Event_Spend_PrdGrp, drEvtSPG)

                // Resolve Belongs to Relationships
                return drEvtSPG.loadRelations([esWB_Meta, esWB_Spend_Type, esWB_Domain_Item])
            }).then((ignore) => {

                // Call After Create
                return self._EventSpendProductGroupRow_AfterCreate(newESPG)

            }).then((ignore) => {


                if (newESPG.WB_EventSpendPrdGrpOverrideRow) {
                    if ('MarginalInd' in opts) {
                        if (!_.isEmpty(opts.MarginalInd)) {
                            newESPG.WB_EventSpendPrdGrpOverrideRow.cif.MARGINAL_SPEND_IND = (opts.MarginalInd) ? "1" : "0"
                        }
                    }

                    newESPG.WB_EventSpendPrdGrpOverrideRow.cif.SPEND_CALC_METHOD = 'Override'

                }

                return ASync.resolve()
            }).then((ignore) => {
                return self.getProductGroupFinishedProducts(newESPG.cif.WB_PRDGRP_ID, {})

            }).then((arrFinishedProductsId) => {

                return self.syncEventSpendProductGroupFinishedProducts(newESPG, arrFinishedProductsId, true, false)

            }).then((ignore) => {

                // Notify changes
                self._notifyEventSpendChanged()
                resolve(self)
            }).catch((err) => {
                error(err)
            })

        })
    }

    private syncEventSpendProductGroupFinishedProducts(aWB_EventSPG: WB_EventSpendPrdGrpRow, arrFinishedProductIds: number[], bAddOnly: boolean = true, bNotifyChange: boolean = false): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.dbContext.findUsingCache(esWB_Finished_Product, arrFinishedProductIds)
                .then((arrFPs: WB_FinishedProductRow[]) => {
                    if (_.isEmpty(arrFPs)) {
                        resolve()
                        return
                    }
                    let dctRowByFinishedProduct = _.keyBy(_.filter(aWB_EventSPG.WB_EventSpendPrdRows, 'isActive'), (aRow) => {
                        return aRow.cif.WB_PROD_ID
                    })
                    let dctRowsToDelete = _.clone(dctRowByFinishedProduct)

                    async function syncSpendProducts() {
                        //
                        for (let idx = 0; idx < arrFPs.length; idx++) {
                            let fpRow = arrFPs[idx]
                            if (!(fpRow.cif.WB_PROD_ID in dctRowByFinishedProduct)) {
                                let anEventSpendProductRow: WB_EventSpendPrdRow = <any>await self.dbContext.createRecordWithKey(esWB_Event_Spend_Prd)
                                anEventSpendProductRow.setDefaults()
                                anEventSpendProductRow.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID
                                anEventSpendProductRow.cif.WB_EVTSPG_ID = aWB_EventSPG.cif.WB_EVTSPG_ID
                                anEventSpendProductRow.cif.WB_PROD_ID = fpRow.cif.WB_PROD_ID
                                anEventSpendProductRow.WB_FinishedProductRow = fpRow
                                self.dbContext.add(esWB_Event_Spend_Prd, anEventSpendProductRow)
                                delete dctRowsToDelete[fpRow.cif.WB_PROD_ID]
                            }
                        }

                        if (!bAddOnly) {
                            _.forEach(dctRowsToDelete, (value: WB_EventSpendPrdRow, key) => {
                                if (value.cif.MANUAL_IND == '1') {
                                    value.markDeleted()
                                }
                            })
                        }

                        if (bNotifyChange) {
                            self.SpendCollectionChanged.next(self)
                        }

                        resolve()
                    }

                    syncSpendProducts()

                }).catch((err) => {
                error(err)
            })
        })
    }


    removeEventSpend(WB_EvtSPG_ID: number): Promise<EventBO> {
        const self = this

        return new Promise<EventBO>((resolve, error) => {

            _.forEach(self.WB_Event.WB_EventSpend_ProductGroupRows, (aRow: WB_EventSpendPrdGrpRow) => {
                if (aRow && aRow.isActive) {
                    if (aRow.cif.WB_EVTSPG_ID == WB_EvtSPG_ID) {
                        aRow.markDeleted()

                        _.forEach(aRow.WB_EventSpendPrdRows, (aPrdRow: WB_EventSpendPrdRow) => {
                            aPrdRow.markDeleted()
                        })
                    }
                }
            })

            self._notifyEventSpendChanged()

            resolve(self)

        })
    }

    get SpendPropertyChanged(): BehaviorSubject<IEventSpendChangedEvent> {
        return this._SpendPropertyChanged
    }

    get SpendCollectionChanged(): BehaviorSubject<EventBO> {
        return this._SpendCollectionChanged
    }

    _notifyEventSpendChanged() {
        this.SpendCollectionChanged.next(this)
    }

//</editor-fold>

    //<editor-fold desc = "IEventRedistributedSpend operations">


    private _RedistributedSpendPropertyChanged: BehaviorSubject<IEventRedistributedSpendChangedEvent>;
    private _RedistributedSpendCollectionChanged: BehaviorSubject<EventBO>;

    private IEventRedistributedSpend_init(): void {
        this._RedistributedSpendPropertyChanged = new BehaviorSubject<IEventRedistributedSpendChangedEvent>(undefined)
        this._RedistributedSpendCollectionChanged = new BehaviorSubject<EventBO>(this)
    }


    private IEventRedistributed_onRecordChange(record: WB_EventSpendPrdGrpRedistribRow, propertyName: string, propertyValue: any, options: EventBO) {
        this.RedistributedSpendPropertyChanged.next({
            EventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    private IEventRedistributedSpendProductGroupMetrics_onRecordChange(record: WB_MetricRow, propertyName: string, propertyValue: any, options: { EventBO: EventBO, Row: WB_EventSpendPrdGrpRedistribRow }) {
        this.RedistributedSpendPropertyChanged.next({
            EventBO: options.EventBO,
            Row: options.Row,
            PropertyChanged: 'WB_EventSpendPrdGrpOverrideRow.WB_MetricRow_ActualOvrd.' + propertyName,
            PropertyValue: propertyValue
        })
    }

    addEventRedistributedSpend(WB_EvtSPG_ID: number, options: IEventRedistributedSpendAddOptions): Promise<EventBO> {
        const self = this
        const opts: IEventRedistributedSpendAddOptions = {}
        _.defaults(opts, options || {}, IEventRedistributedSpendAddOptionsDefault)

        return new Promise<EventBO>((resolve, error) => {

            let aWB_EvtSPG: WB_EventSpendPrdGrpRow = undefined
            let aWB_PrdGrp: WB_ProductGroupRow = undefined
            let aWB_EvtRSPG: WB_EventSpendPrdGrpRedistribRow
            let found = false

            // check if it exists
            _.forEach(_.filter(self.WB_Event.WB_EventSpend_RedistributionRows, 'isActive'), (aRow: WB_EventSpendPrdGrpRedistribRow) => {
                if (aRow.cif.WB_EVTSPG_ID == WB_EvtSPG_ID) {
                    aWB_EvtRSPG = aRow
                    aWB_EvtSPG = aWB_EvtRSPG.WB_EventSpendPrdGrpRow
                    found = true
                    return false
                }
            })

            if (found) {
                // Sync up manual flag ?
                resolve(self)
                return
            }


            self.dbContext.find(esWB_Event_Spend_PrdGrp, WB_EvtSPG_ID)
                .then((WB_EvtSPG: WB_EventSpendPrdGrpRow) => {
                    if (_.isEmpty(WB_EvtSPG)) {
                        error("Unable to find Event SPG")
                        return
                    }
                    aWB_EvtSPG = WB_EvtSPG

                    return self.dbContext.find(esWB_Product_Group, aWB_EvtSPG.cif.WB_PRDGRP_ID)
                }).then((WB_PrdGrp: WB_ProductGroupRow) => {
                if (_.isEmpty(WB_PrdGrp)) {
                    error("Unable to find PrdGrp")
                    return
                }
                aWB_PrdGrp = WB_PrdGrp

                return self.dbContext.createRecordWithKey(esWB_Event_Spend_PrdGrp_Redistrib)
            }).then((WB_ERSPG: WB_EventSpendPrdGrpRedistribRow) => {

                aWB_EvtRSPG = WB_ERSPG
                aWB_EvtRSPG.setDefaults()
                aWB_EvtRSPG.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                aWB_EvtRSPG.WB_EventRow = self.WB_Event
                aWB_EvtRSPG.cif.WB_PRDGRP_ID = aWB_EvtSPG.cif.WB_PRDGRP_ID
                aWB_EvtRSPG.WB_ProductGroupRow = aWB_PrdGrp
                aWB_EvtRSPG.cif.WB_EVTSPG_ID = aWB_EvtSPG.cif.WB_EVTSPG_ID
                aWB_EvtRSPG.WB_EventSpendPrdGrpRow = aWB_EvtSPG
                aWB_EvtRSPG.cif.BASIS_RATE_AMT = opts.AllocationBasisRate || 0
                if ('AllocationBasisId' in opts) {
                    aWB_EvtRSPG.cif.BASIS_ID = opts.AllocationBasisId || 0
                }

                if ('AllocationRuleId' in opts) {
                    aWB_EvtRSPG.cif.WB_SPENDRL_ID = opts.AllocationRuleId || 0
                }

                aWB_EvtRSPG.cif.MANUAL_IND = (opts.bManual) ? '1' : '0'

                return self._EventRedistribSpendProductGroupRow_AfterCreate(aWB_EvtRSPG)
            }).then((ignore) => {
                if (!opts.bSkipNotification) {
                    self.RedistributedSpendCollectionChanged.next(self)
                }
                resolve(self)
            }).catch((err) => {
                error(err)
            })

        })
    }

    removeEventRedistributedSpend(WB_EvtRSPG_ID: number, options?: IEventRedistributedSpendRemoveOptions): Promise<EventBO> {
        const self = this
        const opts: IEventRedistributedSpendRemoveOptions = {}
        _.defaults(opts, options || {}, IEventRedistributedSpendRemoveOptionsDefault)

        let changed = false

        return new Promise<EventBO>((resolve, error) => {
            _.forEach(self.WB_Event.WB_EventSpend_RedistributionRows, (aERSPGRow: WB_EventSpendPrdGrpRedistribRow) => {
                if (!aERSPGRow.isActive) {
                    return
                }

                if (aERSPGRow.cif.WB_EVTRSPG_ID == WB_EvtRSPG_ID) {
                    aERSPGRow.markDeleted()
                    changed = true
                    if (!opts.bSkipNotification) {
                        self.RedistributedSpendPropertyChanged.next({
                            EventBO: self,
                            Row: aERSPGRow,
                            PropertyChanged: 'isActive',
                            PropertyValue: false
                        })
                    }
                }

            })

            if (changed && (!opts.bSkipNotification)) {
                self.RedistributedSpendCollectionChanged.next(self)
            }
        })
    }

    syncOverlappingRedistributedSpend(options?: any): Promise<EventBO> {
        const self: EventBO = this

        return new Promise<EventBO>((resolve, error) => {

            let overlappingEPGS: number[] = []
            let PGsIds = _.map(self.ProductGroups, (pg: WB_ProductGroupRow) => {
                return pg.cif.WB_PRDGRP_ID
            })
            let InStoreRange = self.InStore
            let ShipmentRange = self.Shipment

            // Load the Plan
            self.OnIHavePlanLoaded
                .then((ignore) => {
                    // For Each Event, check, if
                    _.forEach(self.Plan.PlanEvents.Events, (anEvent: EventBO) => {

                        //
                        if (anEvent.bIsDeleted || (anEvent.WB_Event.cif.WB_EVT_ID == self.WB_Event.cif.WB_EVT_ID)) {
                            return
                        }

                        if (!(DateUtils.RangesOverlap(InStoreRange, anEvent.InStore) || DateUtils.RangesOverlap(ShipmentRange, anEvent.Shipment))) {
                            return
                        }

                        // for Each SPG record, add to list
                        _.forEach(anEvent.WB_Event.WB_EventSpend_ProductGroupRows, (aESPGRow: WB_EventSpendPrdGrpRow) => {
                            if (!aESPGRow.isActive) {
                                return
                            }

                            if (_.indexOf(PGsIds, aESPGRow.cif.WB_PRDGRP_ID) != -1) {
                                overlappingEPGS.push(aESPGRow.cif.WB_EVTSPG_ID)
                            }
                        })

                    })

                    return self.syncOverlappingEventRedistributedSpend(overlappingEPGS, {})
                }).then((ignore) => {
                resolve(self)
            }).catch((err) => {
                error(err)
            })

        })
    }

    syncOverlappingEventRedistributedSpend(arrWB_EvtSPG_ID: number[], options: IEventRedistributedSpendSyncOptions): Promise<EventBO> {
        const self = this
        const opts: IEventRedistributedSpendSyncOptions = {}
        _.defaults(opts, options || {}, IEventRedistributedSpendSyncOptionsDefault)

        return new Promise<EventBO>((resolve, error) => {
            // Add Missing, Remove Extra
            let rowsToRemove: WB_EventSpendPrdGrpRedistribRow[] = []
            arrWB_EvtSPG_ID = _.uniq(arrWB_EvtSPG_ID)
            let espgsIdsToAdd: number[] = _.clone(arrWB_EvtSPG_ID)

            _.forEach(_.filter(self.WB_Event.WB_EventSpend_RedistributionRows, 'isActive'), (aRow: WB_EventSpendPrdGrpRedistribRow) => {
                //
                _.remove(espgsIdsToAdd, (aValue: number) => {
                    return (aValue == aRow.cif.WB_EVTSPG_ID)
                })
                if ((aRow.cif.MANUAL_IND == '0') && (aRow.cif.ALLOCATED_SPEND <= 0.01)) {
                    rowsToRemove.push(aRow)
                }
            })


            async function SyncRSPGRows() {
                try {
                    for (let i = 0; i < espgsIdsToAdd.length; i++) {
                        let addId = espgsIdsToAdd[i]
                        await self.addEventRedistributedSpend(addId, {bSkipNotification: true, bManual: false})
                    }

                    for (let i = 0; i < rowsToRemove.length; i++) {
                        await self.removeEventRedistributedSpend(rowsToRemove[i].cif.WB_EVTRSPG_ID, {bSkipNotification: true})
                    }

                    // notify
                    self.RedistributedSpendCollectionChanged.next(self)
                    resolve(self)
                } catch (err) {
                    error(err)
                } finally {

                }
            }

            SyncRSPGRows()
        })

    }

    addManualEventRedistributedSpend(anEventBO: EventBO, options: IEventRedistributedSpendAddOptions): Promise<EventBO> {
        const self = this
        const opts: IEventRedistributedSpendAddOptions = {}
        _.defaults(opts, options || {}, IEventRedistributedSpendAddOptionsDefault)

        const toAdd: number[] = []

        _.forEach(_.filter(anEventBO.WB_Event.WB_EventSpend_ProductGroupRows, 'isActive'), (aRow: WB_EventSpendPrdGrpRow) => {
            toAdd.push(aRow.cif.WB_EVTSPG_ID)
        })

        if (_.isEmpty(toAdd)) {
            return ASync.resolve(self)
        }

        return new Promise<EventBO>((resolve, error) => {
            async function addESPGS() {
                try {
                    opts.bManual = true
                    opts.bSkipNotification = true

                    for (let i = 0; i < toAdd.length; i++) {
                        await self.addEventRedistributedSpend(toAdd[i], opts)
                    }

                    // Notify
                    self.RedistributedSpendCollectionChanged.next(self)

                    resolve()
                } catch (err) {
                    error(err)
                } finally {

                }
            }

            addESPGS()
        })

    }

    get RedistributedSpendPropertyChanged(): BehaviorSubject<IEventRedistributedSpendChangedEvent> {
        return this._RedistributedSpendPropertyChanged
    }

    get RedistributedSpendCollectionChanged(): BehaviorSubject<EventBO> {
        return this._RedistributedSpendCollectionChanged
    }


//</editor-fold>

    //<editor-fold desc = "IHaveSourceCustomers operations">

    SourceCustomersChanged: BehaviorSubject<IHaveSourceCustomers>;

    _bAllSourceCustomersLoaded: boolean;
    _AllSourceCustomers: WB_CustomerRow[];
    _OnIHaveSourceCustomersLoaded: Promise<IHaveSourceCustomers>;

    IHaveSourceCustomers_init(): void {
        this.SourceCustomersChanged = new BehaviorSubject<IHaveSourceCustomers>(this);
        this._AllSourceCustomers = [];
        this._bAllSourceCustomersLoaded = false;
        this._OnIHaveSourceCustomersLoaded = undefined;
    }


    get SourceCustomersReadOnly(): boolean {
        if (this._bIsDeleted) {
            return true
        }

        return false;
    }


    addSourceCustomer(SourceCustomerId: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            self.addEventSourceCustomer(SourceCustomerId, {})
                .then((ignore) => {
                    //self.SourceCustomersChanged.next(self), done by _notifyEventSourceCustomerChanged
                    resolve()
                    return
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    removeSourceCustomer(SourceCustomerId: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            self.removeEventSourceCustomer(SourceCustomerId)
                .then((ignore) => {
                    //self.SourceCustomersChanged.next(self) this is done by _notifyEventSourceCustomerChanged
                    resolve()
                    return
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    hasSourceCustomer(SourceCustomerId: number): boolean {
        var returnValue = false
        _.forEach(this.drWB_Event.WB_Event_SourceCustomerRows, (aSrcCustRelRow: WB_EventCustomerRow) => {
            if (aSrcCustRelRow.isActive && aSrcCustRelRow.WB_CustomerRow) {
                if ((aSrcCustRelRow.WB_CustomerRow.cif.WB_CUST_ID == SourceCustomerId) && (aSrcCustRelRow.cif.EXCLUDE_IND != '1')) {
                    returnValue = true
                    return false // stop iterating
                }
            }
        })
        return returnValue
    }

    isSourceCustomerEditable(SourceCustomerId: number): boolean {
        let returnValue = true

        _.forEach(this.drWB_Event.WB_Event_SourceCustomerRows, (aSrcCustRelRow: WB_EventCustomerRow) => {
            if (aSrcCustRelRow.isActive && aSrcCustRelRow.WB_CustomerRow) {
                if ((aSrcCustRelRow.WB_CustomerRow.cif.WB_CUST_ID == SourceCustomerId) && (aSrcCustRelRow.cif.MANUAL_IND != '1')) {
                    returnValue = false
                    return false // stop iterating
                }
            }
        })

        return returnValue;
    }

    get bIHaveSourceCustomersLoaded(): boolean {
        return this._bAllSourceCustomersLoaded;
    }

    get SourceCustomers(): WB_CustomerRow[] {
        let returnValue: WB_CustomerRow[] = []
        _.forEach(this.drWB_Event.WB_Event_SourceCustomerRows, (aSrcCustRelRow: WB_EventCustomerRow) => {
            if (aSrcCustRelRow.isActive && aSrcCustRelRow.WB_CustomerRow && (aSrcCustRelRow.cif.EXCLUDE_IND != '1')) {
                returnValue.push(aSrcCustRelRow.WB_CustomerRow)
            }
        })
        return returnValue
    }

    get AllSourceCustomers(): WB_CustomerRow[] {
        return this._AllSourceCustomers;
    }

    get OnIHaveSourceCustomersLoaded(): Promise<IHaveSourceCustomers> {
        const self = this;

        if (self._bAllSourceCustomersLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveSourceCustomersLoaded))
            return self._OnIHaveSourceCustomersLoaded; // Load already started, wait on same Promise

        self._OnIHaveSourceCustomersLoaded = new Promise<IHaveSourceCustomers>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            if ((!(self.bIsLoaded)) && (_.isEmpty(self.OnLoadComplete))) {
                error("Event isn't Loaded or Loading.. Can't determine Source Customers");
                return;
            }

            var loadWait: Promise<any> = undefined

            if (self.bIsLoaded) {
                loadWait = ASync.resolve(self)
            } else {
                loadWait = self.OnLoadComplete
            }

            loadWait
                .then((anEventBO) => {
                    if (anEventBO.bIsLoaded) {
                        return self.OnAllSourceCustomersLoaded_WhenPlanIsLoaded
                    } else {
                        error("Waited on Plan Load to complete but still isn't Loaded");
                    }
                })
                .then((src_cust_rows) => {
                    resolve(self);
                })
                .catch((err) => {
                    error(err)
                });

        })

        return self._OnIHaveSourceCustomersLoaded;
    }

    get OnAllSourceCustomersLoaded_WhenPlanIsLoaded(): Promise<WB_CustomerRow[]> {
        const self = this;
        return new Promise<WB_CustomerRow[]>((resolve, error) => {
            // Event Is Loaded..
            // Determine the Planning Customer/ Sub Planning Customer
            let iPlanningCustomer = _.toNumber(self.WB_Event.cif.WB_CUST_ID_PLANNING);
            let iSubPlanningCustomer = _.toNumber(self.WB_Event.cif.WB_CUST_ID_SUBPLANNING);

            let iParentCustomers: number[] = []
            if (_.isNumber(iPlanningCustomer) && (iPlanningCustomer != 0))
                iParentCustomers.push(iPlanningCustomer)
            if (_.isNumber(iSubPlanningCustomer) && (iSubPlanningCustomer != 0))
                iParentCustomers.push(iSubPlanningCustomer)

            let iSourceCustomersIds: number[] = []

            let aSourceCustomerService = new SourceCustomerService();
            aSourceCustomerService.getSrcCustIdsbyParent(iParentCustomers)
                .then((arrSourceCustomers) => {
                    iSourceCustomersIds = arrSourceCustomers

                    if (iSourceCustomersIds.length > 0) {
                        return self.dbContext.findAll(esWB_Customer, {where: {WB_CUST_ID: {'inq': iSourceCustomersIds}}})
                    } else {
                        return ASync.resolve([])
                    }

                })
                .then((src_cust_rows) => {
                    self._AllSourceCustomers = src_cust_rows;
                    self._bAllSourceCustomersLoaded = true;
                    self._OnIHaveSourceCustomersLoaded = undefined;
                    resolve(src_cust_rows);
                })
                .catch((err) => {
                    error(err);// crap happened
                })
        });
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveProductGroup operations">

    _bIHaveProductGroupsLoaded: boolean;
    _OnIHaveProductGroupsLoaded: Promise<IHaveProductGroups>;
    _dctIHaveProductGroups_built: boolean
    _dctIHaveProductGroups: { [wbPrdGrpId: number]: WB_EventProductGroupRow }

    IHaveProductGroups_init() {
        this.ProductGroupsChanged = new BehaviorSubject<IHaveProductGroups>(this);
        this._bIHaveProductGroupsLoaded = false;
        this._OnIHaveProductGroupsLoaded = undefined;
        this._dctIHaveProductGroups_reset()
    }

    private _dctIHaveProductGroups_reset(): void {
        this._dctIHaveProductGroups_built = false
        this._dctIHaveProductGroups = {}
    }

    private _dctIHaveProductGroups_ready(): void {

        if (this._dctIHaveProductGroups_built)
            return;

        let arrFiltered = _.filter(this.drWB_Event.WB_Event_ProductGroupRows, (epg: WB_EventProductGroupRow) => (epg.isActive && !_.isEmpty(epg.WB_ProductGroupRow)))
        this._dctIHaveProductGroups = _.keyBy(arrFiltered, (a) => a.WB_ProductGroupRow.cif.WB_PRDGRP_ID)

        this._dctIHaveProductGroups_built = true
    }


    ProductGroupsChanged: BehaviorSubject<IHaveProductGroups>;

    get bIHaveProductGroupsLoaded(): boolean {
        return this._bIHaveProductGroupsLoaded
    }

    get OnIHaveProductGroupsLoaded(): Promise<IHaveProductGroups> {
        const self = this;

        if (self._OnIHaveProductGroupsLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveProductGroupsLoaded)) {
            return self._OnIHaveProductGroupsLoaded; // Load already started, wait on same Promise
        }

        self._OnIHaveProductGroupsLoaded = new Promise<IHaveProductGroups>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            if ((!(self.bIsLoaded)) && (_.isEmpty(self.OnLoadComplete))) {
                error("Event isn't Loaded or Loading.. Can't determine Product Groups");
                return;
            }

            var loadWait: Promise<any>
            if (self.bIsLoaded) {
                loadWait = ASync.resolve(self)
            } else {
                loadWait = this.OnLoadComplete
            }

            loadWait
                .then((aEventBO) => {
                    if (!aEventBO.bIsLoaded) {
                        error("Waited on Event Load to complete but still isn't Loaded")
                        return
                    }

                    // wait for Plan to Load, if not loaded
                    if (self.bIHavePlanLoaded) {
                        return ASync.resolve(self)
                    } else {
                        if (_.isEmpty(self.OnIHavePlanLoaded)) {
                            error("Event Plan isn't Loaded or Loading..Can't determine Product Groups")
                            return
                        }

                        return self.OnIHavePlanLoaded
                    }
                }).then((ignore) => {

                // Setup Product Group Collection, flag loaded.
                this._bIHaveProductGroupsLoaded = true;
                this._OnIHaveProductGroupsLoaded = undefined
                resolve(self)
            })

        });

        return self._OnIHaveProductGroupsLoaded;
    }

    get ProductGroups(): WB_ProductGroupRow[] {
        var returnValue: WB_ProductGroupRow[] = []

        _.forEach(this.drWB_Event.WB_Event_ProductGroupRows, (epg: WB_EventProductGroupRow) => {
            if (epg && epg.isActive && !_.isEmpty(epg.WB_ProductGroupRow)) {
                returnValue.push(epg.WB_ProductGroupRow)
            }
        })

        return returnValue
    }

    get AllProductGroups(): WB_ProductGroupRow[] {
        // The load Promise waits for this, so it should be true.
        if (this.bIHavePlanLoaded) {
            return this.Plan.AllProductGroups
        } else {
            return this.ProductGroups
        }
    }

    get ProductGroupsReadOnly(): boolean {
        if (this.bIsDeleted) {
            return true;
        } else {
            // check user roles ?
            return false
        }
    }

    addProductGroup(ProductGroupId: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.addEventProductGroup(ProductGroupId, {})
                .then((ignore) => {
                    //self.ProductGroupsChanged.next(self)
                    // fired by       self._notifyEventProductGroupChanged()
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    removeProductGroup(ProductGroupId: number): Promise<void> {

        const self = this

        return new Promise<void>((resolve, error) => {
            self.removeEventProductGroup(ProductGroupId)
                .then((ignore) => {
                    //self.ProductGroupsChanged.next(self)
                    // fired by       self._notifyEventProductGroupChanged()
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    hasProductGroup(ProductGroupId: number): boolean {

        this._dctIHaveProductGroups_ready()

        return (ProductGroupId in this._dctIHaveProductGroups)

    }

    isProductGroupEditable(ProductGroupId: number): boolean {

        this._dctIHaveProductGroups_ready()

        if (!(ProductGroupId in this._dctIHaveProductGroups))
            return true; // not in event, so can be added.

        let rec = this._dctIHaveProductGroups[ProductGroupId]

        return (rec?.cif?.MANUAL_IND == '1')

    }


//</editor-fold>

    //<editor-fold desc = "IHaveExecutionDates operations">

    IHaveExecutionDates_init(): void {
        this._bIHaveExecutionDatesLoaded = false
        this._OnIHaveExecutionDatesLoaded = undefined
        this.DatesChanged = new BehaviorSubject<IHaveExecutionDates>(this)
    }

    _bIHaveExecutionDatesLoaded: boolean
    _OnIHaveExecutionDatesLoaded: Promise<IHaveExecutionDates>

    get bIHaveExecutionDatesLoaded(): boolean {
        return this._bIHaveExecutionDatesLoaded
    }

    get OnIHaveExecutionDatesLoaded(): Promise<IHaveExecutionDates> {
        const self = this;
        // triggers load progress, if not loaded

        // if loaded, resolve with self
        if (this._bIHaveExecutionDatesLoaded) {
            return ASync.resolve(self);
        }

        // if load in progress, wait on same load
        if (!_.isEmpty(this._OnIHaveExecutionDatesLoaded)) {
            return this._OnIHaveExecutionDatesLoaded
        }

        self._OnIHaveExecutionDatesLoaded = new Promise<IHaveExecutionDates>((resolve, reject) => {
            // check if BO is loaded
            if (self.bIsLoaded) {
                resolve(self)
                return;
            }

            if (_.isEmpty(self.OnLoadComplete)) {
                reject("Event failed to Load")
                return;
            }

            self.OnLoadComplete
                .then((aEventBO) => {

                    self._bIHaveExecutionDatesLoaded = true
                    self._OnIHaveExecutionDatesLoaded = undefined
                    resolve(self)
                })
                .catch((err) => {
                    reject(err)
                })

        })

        return self._OnIHaveExecutionDatesLoaded
    }

    // InStore
    get InStore(): IDateRange {
        return DateUtils.coalesce(this.drWB_Event.WB_EventOverrideRow.InStore.Range, this.drWB_Event.InStore.Range)
    }

    set InStore(value: IDateRange) {
        this.drWB_Event.WB_EventOverrideRow.InStore.Range = value
        this.DatesChanged.next(this)
    }

    get InStoreSource(): IDateRange {
        return this.WB_Event.InStore.Range
    }

    get InStoreBounds(): IDateRange {
        let rng = this.drWB_Event.WB_PlanRow.InStore.Range
        return {StartDt: DateUtils.addDays(rng.StartDt, -100), EndDt: DateUtils.addDays(rng.EndDt, 100)}
    }

    get bInStoreDatesExist(): boolean {
        return true;
    }

    get bInStoreDatesValid(): boolean {
        var r = this.InStore
        if (!r) {
            return false
        }

        if (r.StartDt && r.EndDt) {
            if (r.StartDt > r.EndDt) {
                return false
            }
            if (r.StartDt < this.InStoreBounds.StartDt) {
                return false
            }
            if (r.EndDt > this.InStoreBounds.EndDt) {
                return false
            }
            return true
        } else {
            return false // one of them is undefined
        }
    }

    get bInStoreDatesReadOnly(): boolean {
        return this.bIsDeleted
    }


// Shipment
    get Shipment(): IDateRange {
        return DateUtils.coalesce(this.drWB_Event.WB_EventOverrideRow.Shipment.Range, this.drWB_Event.Shipment.Range)
    }

    set Shipment(value: IDateRange) {
        this.drWB_Event.WB_EventOverrideRow.Shipment.Range = value
        this.DatesChanged.next(this)
    }

    get ShipmentSource(): IDateRange {
        return this.WB_Event.Shipment.Range
    }

    get ShipmentBounds(): IDateRange {
        let rng = this.drWB_Event.WB_PlanRow.Shipment.Range
        return {StartDt: DateUtils.addDays(rng.StartDt, -120), EndDt: DateUtils.addDays(rng.EndDt, 120)}
    }

    get bShipmentDatesExist(): boolean {
        return true;
    }

    get bShipmentDatesValid(): boolean {
        var r = this.Shipment
        if (!r) {
            return false
        }

        if (r.StartDt && r.EndDt) {
            if (r.StartDt > r.EndDt) {
                return false
            }
            if (r.StartDt < this.ShipmentBounds.StartDt) {
                return false
            }
            if (r.EndDt > this.ShipmentBounds.EndDt) {
                return false
            }
            return true
        } else {
            return false // one of them is undefined
        }
    }

    get bShipmentDatesReadOnly(): boolean {
        return this.bIsDeleted
    }

    get Order(): IDateRange {
        return {StartDt: undefined, EndDt: undefined}
    }

    set Order(value: IDateRange) {
        return;
    }

    get OrderSource(): IDateRange {
        return this.Order
    }

    get OrderBounds(): IDateRange {
        return {StartDt: undefined, EndDt: undefined}
    }

    get bOrderDatesExist(): boolean {
        return false
    }

    get bOrderDatesValid(): boolean {
        return true;
    }

    get bOrderDatesReadOnly(): boolean {
        return true
    }

    getProductsByProductGroup(wbPGId: number): WB_FinishedProductRow[] {
        let self = this
        let returnVal: WB_FinishedProductRow[] = []
        let pgRow = _.first(_.filter(self.WB_Event.WB_Event_ProductGroupRows, aRow => aRow.isActive && aRow.cif.WB_PRDGRP_ID == wbPGId))
        if (!_.isEmpty(pgRow)) {
            returnVal = _.map(pgRow.WB_EventProductRows, aRow => {
                if (aRow.isActive) return aRow.WB_FinishedProductRow
            })
        }
        return returnVal
    }

    DatesChanged: BehaviorSubject<IHaveExecutionDates>;


//</editor-fold>

    //<editor-fold desc = "IHaveTags operations">

    _bIHaveTagsLoaded: boolean;
    _OnIHaveTagsLoaded: Promise<IHaveTags>;
    _TagsChanged: BehaviorSubject<IHaveTags>;
    _TagBag: TagBag;
    _TagUsageId: string;

    IHaveTagsLoaded_init() {
        this._bIHaveTagsLoaded = false
        this._OnIHaveTagsLoaded = undefined
        this._TagsChanged = new BehaviorSubject<IHaveTags>(this)
        this._TagBag = undefined
        this._TagUsageId = 'AllTagUsage'
    }

    get bIHaveTagsLoaded() {
        return this._bIHaveTagsLoaded
    }

    get TagsReadOnly(): boolean {
        if (this._bIsDeleted) {
            return true
        }
        // Check User Roles ?

        return false
    }

    get Tags(): WB_TagRow[] {
        var returnValue: WB_TagRow[] = []

        _.forEach(this.drWB_Event.WB_Event_TagRows, (aWBEvtTagRow: WB_EventTagRow) => {
            if (aWBEvtTagRow && aWBEvtTagRow.isActive && aWBEvtTagRow.WB_TagRow) {
                returnValue.push(aWBEvtTagRow.WB_TagRow)
            }
        })

        return returnValue
    }

    get TagsChanged(): BehaviorSubject<IHaveTags> {
        return this._TagsChanged
    }

    get AllTags(): WB_TagRow[] {
        if (this._TagBag) {
            return this._TagBag.AllTags
        } else {
            return []
        }
    }

    get UsageId(): string {
        return this._TagUsageId
    }

    get OnIHaveTagsLoaded(): Promise<IHaveTags> {
        const self = this;

        if (self._bIHaveTagsLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveTagsLoaded)) {
            return self._OnIHaveTagsLoaded;
        }

        self._OnIHaveTagsLoaded = new Promise<IHaveTags>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            if ((!(self.bIsLoaded)) && (_.isEmpty(self.OnLoadComplete))) {
                error("Event isn't Loaded or Loading.. Can't determine Tags");
                return;
            }

            var loadWait: Promise<any> = undefined

            if (self.bIsLoaded) {
                loadWait = ASync.resolve(self)
            } else {
                loadWait = self.OnLoadComplete
            }

            loadWait
                .then((aEventBO) => {
                    if (!(aEventBO.bIsLoaded)) {
                        error("Waited on Event Load to complete but still isn't Loaded");
                        return
                    }

                    let PlanRow = self.WB_Event.WB_PlanRow
                    if (PlanRow && PlanRow.WB_PlanTypeRow && PlanRow.WB_PlanTypeRow.cif.WB_TAG_ID_USAGE > 0) {
                        return self.dbContext.find(esWB_Tag, PlanRow.WB_PlanTypeRow.cif.WB_TAG_ID_USAGE)
                    }
                })
                .then((tagRow: WB_TagRow) => {
                    if (tagRow) {
                        self._TagUsageId = tagRow.cif.TAG_ID
                    }

                    self._TagBag = new TagBag({dbContext: self.dbContext, TagUsage: self._TagUsageId})

                    return self._TagBag.OnIHaveTagsLoaded

                })
                .then((ignore) => {
                    self._bIHaveTagsLoaded = true
                    self._OnIHaveTagsLoaded = undefined
                    resolve(self);
                })
                .catch((err) => {
                    self._OnIHaveTagsLoaded = undefined
                    error(err)
                });

        })

        return self._OnIHaveTagsLoaded;

    }


    addTag(TagId: number): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            var aTagRow: WB_TagRow = undefined
            var found: boolean = false
            _.forEach(self.drWB_Event.WB_Event_TagRows, (aTagRow: WB_EventTagRow) => {
                if (aTagRow.cif.WB_TAG_ID === TagId) {
                    aTagRow.cif.DELETED_IND = ""
                    found = true
                }
            })

            self.dbContext.find(esWB_Tag, TagId)
                .then((aNewRow: WB_TagRow) => {
                    if (!(aNewRow)) {
                        error("Unable to find Tag to add to Event. " + TagId)
                        return
                    }

                    aTagRow = aNewRow

                    return self.dbContext.createRecordWithKey(esWB_Event_Tag)

                })
                .then((aWBEvtTag: WB_EventTagRow) => {
                    //
                    if (!(aWBEvtTag)) {
                        error("Unable to create Event Tag record add to Event. ")
                        return
                    }
                    let shouldAdd = true
                    aWBEvtTag.setDefaults()
                    aWBEvtTag.WB_TagRow = aTagRow
                    aWBEvtTag.cif.WB_TAG_ID = aTagRow.cif.WB_TAG_ID
                    aWBEvtTag.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID
                    aWBEvtTag.cif.TAG_METHOD = "Manual"
                    aWBEvtTag.WB_TagRow = aTagRow
                    if (!found)
                        self.dbContext.add(esWB_Event_Tag, aWBEvtTag)
                    self.TagsChanged.next(self)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    removeTag(TagId: number): void {
        const self = this
        var changed = false
        _.forEach(self.drWB_Event.WB_Event_TagRows, (aWBEvtTagRow: WB_EventTagRow) => {
            if (aWBEvtTagRow && aWBEvtTagRow.isActive && aWBEvtTagRow.WB_TagRow) {
                if (aWBEvtTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    aWBEvtTagRow.markDeleted()
                    changed = true
                }
            }
        })

        if (changed) {
            self.TagsChanged.next(self)
        }

    }

    hasTag(TagId: number): boolean {
        var found = false

        _.forEach(this.drWB_Event.WB_Event_TagRows, (aWBEvtTagRow: WB_EventTagRow) => {
            if (aWBEvtTagRow && aWBEvtTagRow.isActive && aWBEvtTagRow.WB_TagRow) {
                if (aWBEvtTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    found = true
                    return false // stop iterating
                }
            }
        })

        return found
    }

//</editor-fold>

    //<editor-fold desc = "IHaveFinishedProducts operations">

    _bIHaveFinishedProductsLoaded: boolean;
    _OnIHaveFinishedProductsLoaded: Promise<IHaveFinishedProducts>;
    FinishedProductsChanged: BehaviorSubject<IHaveFinishedProducts>;

    IHaveFinishedProducts_init(): void {

        this._bIHaveFinishedProductsLoaded = false
        this._OnIHaveFinishedProductsLoaded = undefined
        this.FinishedProductsChanged = new BehaviorSubject<IHaveFinishedProducts>(this)

    }


    get bIHaveFinishedProductsLoaded(): boolean {
        return this._bIHaveFinishedProductsLoaded
    }

    get FinishedProductsReadOnly(): boolean {
        return true
    }

    get FinishedProducts(): WB_FinishedProductRow[] {
        var returnValue: WB_FinishedProductRow[] = []
        _.forEach(this.drWB_Event.WB_Event_ProductGroupRows,
            (aEvtPG: WB_EventProductGroupRow) => {
                if (aEvtPG && aEvtPG.isActive) {
                    _.forEach(aEvtPG.WB_EventProductRows,
                        (aEvtPrd: WB_EventProductRow) => {
                            if (aEvtPrd && aEvtPrd.isActive && aEvtPrd.WB_FinishedProductRow) {
                                returnValue.push(aEvtPrd.WB_FinishedProductRow)
                            }
                        })
                }
            })
        return returnValue
    }

    get AllFinishedProducts(): WB_FinishedProductRow[] {
        // At some point, get from Plan.
        return this.FinishedProducts
    }

    get OnIHaveFinishedProductsLoaded(): Promise<IHaveFinishedProducts> {
        const self = this;
        // triggers load progress, if not loaded

        // if loaded, resolve with self
        if (this._bIHaveFinishedProductsLoaded)
            return ASync.resolve(self);

        // if load in progress, wait on same load
        if (!_.isEmpty(this._OnIHaveFinishedProductsLoaded)) {
            return this._OnIHaveFinishedProductsLoaded
        }

        self._OnIHaveFinishedProductsLoaded = new Promise<IHaveFinishedProducts>((resolve, reject) => {
            // check if BO is loaded
            if (self.bIsLoaded) {
                resolve(self)
                return;
            }

            if (_.isEmpty(self.OnLoadComplete)) {
                reject("Event failed to Load")
                return;
            }

            self.OnLoadComplete
                .then((aEventBO) => {

                    self._bIHaveFinishedProductsLoaded = true
                    self._OnIHaveFinishedProductsLoaded = undefined // should we do this, or just hold onto it ?
                    resolve(self)
                })
                .catch((err) => {
                    reject(err)
                })

        })

        return self._OnIHaveFinishedProductsLoaded
    }


    addFinishedProduct(WB_Prod_Id: number): Promise<void> {
        return ASync.error("Adding Finished Products to Events is not Implemented");
    }

    removeFinishedProduct(WB_Prod_Id: number): void {
        // Not implemented... should not be called
    }

    hasFinishedProduct(WB_Prod_Id: number): boolean {
        return true
    }

    async addShipperSpendProduct(WB_Prod_Id: number, options?: any): Promise<void> {
        let self = this
        let aWBEvtSpendShipPrd: WB_EvtSShpPrdRow = <WB_EvtSShpPrdRow>await self.dbContext.createRecordWithKey(esWB_EvtSShpPrd)
        if (!(aWBEvtSpendShipPrd)) {
            console.log("Unable to create Event Shipper Product record to Event. ")
            return
        }

        let aPrdRecord = await self.dbContext.find(esWB_Finished_Product, WB_Prod_Id)

        if (!aPrdRecord)
            return

        aWBEvtSpendShipPrd.setDefaults()
        aWBEvtSpendShipPrd.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID;
        aWBEvtSpendShipPrd.cif.WB_PROD_ID = WB_Prod_Id
        aWBEvtSpendShipPrd.WB_FinishedProductRow = aPrdRecord
        aWBEvtSpendShipPrd.cif.DEAL_START_DT = self.WB_Event.cif.INSTORE_START_DT
        aWBEvtSpendShipPrd.cif.DEAL_END_DT = self.WB_Event.cif.INSTORE_END_DT
        aWBEvtSpendShipPrd.cif.INSTORE_START_DT = self.WB_Event.cif.INSTORE_START_DT
        aWBEvtSpendShipPrd.cif.INSTORE_END_DT = self.WB_Event.cif.INSTORE_END_DT
        aWBEvtSpendShipPrd.cif.SHIPMENT_START_DT = self.WB_Event.cif.SHIPMENT_START_DT
        aWBEvtSpendShipPrd.cif.SHIPMENT_END_DT = self.WB_Event.cif.SHIPMENT_END_DT
        self.dbContext.add(esWB_EvtSShpPrd, aWBEvtSpendShipPrd)
        let anEPGO: any = {}
        if (!_.isEmpty(aWBEvtSpendShipPrd.WB_EvtSShpPrdOverrideRow)) {
            anEPGO = aWBEvtSpendShipPrd.WB_EvtSShpPrdOverrideRow
        } else {
            anEPGO = <any>self.dbContext.createRecord(esWB_EvtSShpPrdO)
            anEPGO.setDefaults()
            anEPGO.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
            anEPGO.cif.WB_EVTSSHPPRD_ID = aWBEvtSpendShipPrd.cif.WB_EVTSSHPPRD_ID
            anEPGO.cif.WB_PROD_ID = aWBEvtSpendShipPrd.cif.WB_PROD_ID
            aWBEvtSpendShipPrd.WB_EvtSShpPrdOverrideRow = anEPGO

            self.dbContext.add(esWB_EvtSShpPrdO, anEPGO)
        }
        // create Missing Metrics Records
        let tasks: Promise<any>[] = []

        if (_.isEmpty(anEPGO.WB_MetricRow_Actual)) {
            tasks.push(
                self.dbContext.createRecordWithKey(esWB_Metric)
                    .then((drMetrics: WB_MetricRow) => {
                        drMetrics.setDefaults()
                        drMetrics.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                        drMetrics.cif.WB_PLAN_ID = self.WB_Event.cif.WB_PLAN_ID
                        drMetrics.cif.REFERENCE_LEVEL_ID = 'EventSPG'
                        drMetrics.cif.METRIC_TYPE_ID = 'Actual'
                        drMetrics.cif.REFERENCE_ID = aWBEvtSpendShipPrd.cif.WB_EVTSSHPPRD_ID
                        drMetrics.cif.REFERENCE_ID_UI = self.WB_Event.cif.EVENT_ID + '-S-' + aWBEvtSpendShipPrd.cif.WB_PROD_ID
                        //drMetrics.cif.WB_PROD_ID = aWBEvtSpendShipPrd.cif.WB_PROD_ID;
                        self.dbContext.add(esWB_Metric, drMetrics);
                        anEPGO.WB_MetricRow_Actual = drMetrics;
                    }))
        }

        if (_.isEmpty(anEPGO.WB_MetricRow_ActualOvrd)) {
            tasks.push(
                self.dbContext.createRecordWithKey(esWB_Metric)
                    .then((drMetrics: WB_MetricRow) => {
                        drMetrics.setDefaults()
                        drMetrics.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                        drMetrics.cif.WB_PLAN_ID = self.WB_Event.cif.WB_PLAN_ID
                        drMetrics.cif.REFERENCE_LEVEL_ID = 'EventSPG'
                        drMetrics.cif.METRIC_TYPE_ID = 'ActualOvrd'
                        drMetrics.cif.REFERENCE_ID = aWBEvtSpendShipPrd.cif.WB_EVTSSHPPRD_ID
                        drMetrics.cif.REFERENCE_ID_UI = self.WB_Event.cif.EVENT_ID + '-S-' + aWBEvtSpendShipPrd.cif.WB_PROD_ID
                        // drMetrics.cif.WB_PRDGRP_ID = aWBEvtSpendShipPrd.cif.WB_PRDGRP_ID;
                        self.dbContext.add(esWB_Metric, drMetrics);
                        anEPGO.WB_MetricRow_ActualOvrd = drMetrics;
                    }))
        }
        // }
        await Promise.all(tasks)


    }

    removeShipperSpendProduct(WB_EvtShipSpendPrd_ID: number): Promise<EventBO> {
        const self = this

        return new Promise<EventBO>((resolve, error) => {

            _.forEach(this.drWB_Event.WB_EvtSShpPrdRows, (epg: WB_EvtSShpPrdRow) => {
                if (epg && epg.isActive) {
                    if ((epg.cif.WB_EVTSSHPPRD_ID == WB_EvtShipSpendPrd_ID)
                        && (epg.cif.MANUAL_IND == '1')) {
                        epg.markDeleted()
                        if (epg.WB_EvtSShpPrdOverrideRow) {
                            epg.WB_EvtSShpPrdOverrideRow.markDeleted()


                            if (epg?.WB_EvtSShpPrdOverrideRow?.WB_MetricRow_Actual) {
                                epg.WB_EvtSShpPrdOverrideRow.WB_MetricRow_Actual.markDeleted()
                            }
                            if (epg?.WB_EvtSShpPrdOverrideRow?.WB_MetricRow_ActualOvrd) {
                                epg.WB_EvtSShpPrdOverrideRow.WB_MetricRow_ActualOvrd.markDeleted()
                            }

                        }
                    }
                }
            })


            resolve(self)
        })


    }

//</editor-fold>

    //<editor-fold desc = "IHaveExecutionBounds operations">

    IHaveExecutionBounds_init(): void {
        const self = this
        this._bIHaveExecutionBoundsLoaded = false
        this._OnIHaveExecutionBoundsLoaded = undefined
        this.ExecutionBoundsChanged = new BehaviorSubject<IHaveExecutionBounds>(this)


        // Listen to other aspects, to reflect their changes..
        this.SourceCustomersChanged.subscribe((aBO: any) => {
            self._notifyIHaveExecutionBoundsChanged()
        })

        this.SourceCustomerPropertyChanged.subscribe((changeEvent: IEventSourceCustomerChangedEvent) => {

            if (_.isEmpty(changeEvent)) {
                return
            }
            switch (changeEvent.PropertyChanged) {
                case 'EXCLUDE_IND':
                    self._notifyIHaveExecutionBoundsChanged()
                    break;
            }
        })

        this.DatesChanged.subscribe((aBO: any) => {
            self._notifyIHaveExecutionBoundsChanged()
        })

        this.ProductGroupsChanged.subscribe((aBO: any) => {
            self._notifyIHaveExecutionBoundsChanged()
        })

        this.FinishedProductsChanged.subscribe((aBO) => {
            self._notifyIHaveExecutionBoundsChanged()
        })

    }

    private _notifyIHaveExecutionBoundsChanged(): void {
        const self = this

        // This is getting fired before the Event is loaded..
        let prms: Promise<any>
        // Recalc Alignment Dates (Reconsider the placement of this...)
        if (self.WB_Event && self.ActualsCalculator) {
            prms = self.ActualsCalculator.AlignDates()
        } else {
            prms = ASync.resolve()
        }

        prms.then((ignore) => {
            // Notify
            self.ExecutionBoundsChanged.next(self)
        })

    }

    _bIHaveExecutionBoundsLoaded: boolean
    _OnIHaveExecutionBoundsLoaded: Promise<IHaveExecutionBounds>


    get bIHaveExecutionBoundsLoaded(): boolean {
        return this._bIHaveExecutionBoundsLoaded
    };

    get OnIHaveExecutionBoundsLoaded(): Promise<IHaveExecutionBounds> {

        const self = this

        if (self.bIHaveExecutionBoundsLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(this._OnIHaveExecutionBoundsLoaded)) {
            return this._OnIHaveExecutionBoundsLoaded
        }

        this._OnIHaveExecutionBoundsLoaded = new Promise<IHaveExecutionBounds>((resolve, error) => {
            var childTasks: Promise<any>[] = []
            if (!this.bIHaveExecutionDatesLoaded) {
                childTasks.push(this.OnIHaveExecutionDatesLoaded)
            }

            if (!this.bIHaveSourceCustomersLoaded) {
                childTasks.push(self.OnIHaveSourceCustomersLoaded)
            }

            if (!this.bIHaveProductGroupsLoaded) {
                childTasks.push(self.OnIHaveProductGroupsLoaded)
            }

            if (!this.bIHaveFinishedProductsLoaded) {
                childTasks.push(self.OnIHaveFinishedProductsLoaded)
            }

            if (childTasks.length == 0) {
                this._bIHaveExecutionBoundsLoaded = true
                this._OnIHaveExecutionBoundsLoaded = undefined
                resolve(self)
            } else {
                Promise.all(childTasks)
                    .then((ignored) => {
                        this._bIHaveExecutionBoundsLoaded = true
                        this._OnIHaveExecutionBoundsLoaded = undefined
                        resolve(self)
                    })
                    .catch((err) => {
                        this._OnIHaveExecutionBoundsLoaded = undefined
                        error(err)
                    })
            }

        })

        return this._OnIHaveExecutionBoundsLoaded
    }

    get Execution_Bounds_Identity(): IIdentityProvider {
        return this.Identity
    }

    get Execution_InStore(): IDateRange {
        return this.InStore
    }

    get Execution_InStore_Aligned(): IDateRange {
        return DateUtils.coalesce(this.WB_Event.WB_EventOverrideRow.InStoreAligned.Range, this.InStore)
    }

    get Execution_Shipment(): IDateRange {
        return this.Shipment
    }

    get Execution_Shipment_Aligned(): IDateRange {
        return DateUtils.coalesce(this.WB_Event.WB_EventOverrideRow.ShipmentAligned.Range, this.Shipment)
    }

    get Execution_ProductGroups(): WB_ProductGroupRow[] {
        return this.ProductGroups
    }

    get Execution_FinishedProducts(): WB_FinishedProductRow[] {
        return this.FinishedProducts
    }

    get Execution_PlanningCustomers(): WB_CustomerRow[] {
        return [this.drWB_Event.WB_CustomerRow_Planning]
    }

    get Execution_SourceCustomers(): WB_CustomerRow[] {
        if (this.SourceCustomers.length) {
            return this.SourceCustomers
        } else {
            return this.AllSourceCustomers
        }
    }

    ExecutionBoundsChanged: BehaviorSubject<IHaveExecutionBounds>;

//</editor-fold>

    //<editor-fold desc = "IHavePlan operations">


    private _bIHavePlanLoaded: boolean;
    private _OnIHavePlanLoaded: Promise<IHavePlan>;
    private _Plan: PlanBO;

    private setPlan(aPlanBO: PlanBO) {
        this._bIHavePlanLoaded = true
        this._Plan = aPlanBO
    }

    private IHavePlan_init(): void {
        this._bIHavePlanLoaded = false
        this._OnIHavePlanLoaded = undefined
        this._Plan = undefined
    }

    get bIHavePlanLoaded(): boolean {
        return this._bIHavePlanLoaded
    }

    get OnIHavePlanLoaded(): Promise<IHavePlan> {
        const self = this;
        // triggers load progress, if not loaded

        // if loaded, resolve with self
        if (this._bIHavePlanLoaded)
            return ASync.resolve(self);

        // if load in progress, wait on same load
        if (!_.isEmpty(this._OnIHavePlanLoaded)) {
            return this._OnIHavePlanLoaded
        }

        self._OnIHavePlanLoaded = new Promise<IHavePlan>((resolve, reject) => {
            // check if BO is loaded

            var boLoadWait: Promise<IBusinessObject>
            if (self.bIsLoaded) {
                boLoadWait = ASync.resolve(self)
            } else {
                if (_.isEmpty(self.OnLoadComplete)) {
                    reject("Event failed to Load")
                    return;
                }

                boLoadWait = self.OnLoadComplete
            }

            boLoadWait
                .then((aEventBO) => {

                    // Load the Plan BO
                    self._Plan = new PlanBO()
                    return self._Plan.Load(self.drWB_Event.cif.WB_PLAN_ID, {dbContext: self.dbContext})

                }).then((aPlanBO) => {
                if (!(aPlanBO.bIsLoaded)) {
                    reject("Event Plan failed to load: " + aPlanBO.LoadProgressProvider.process_exception)
                    return
                }
                self._bIHavePlanLoaded = true
                self._OnIHavePlanLoaded = undefined // should we do this, or just hold onto it ?
                resolve(self)
            }).catch((err) => {
                reject(err)
            })

        })

        return self._OnIHavePlanLoaded
    }

    get Plan(): PlanBO {
        return this._Plan
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>
    private _Lock: ILock

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
        this._Lock = undefined
    }

    IHaveSecurity_beforeReload() {
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }


        let aHasRolePolicy: PolicyHasRole

        let returnValue = this._OnIHaveSecurityLoaded = (async (): Promise<IHaveSecurity> => {

            let aLock: ILock = undefined
            try {
                if (!PAEnvironment.isNode()) {
                    if (_.isEmpty(self._Lock)) {
                        let aLockService = new PALockClient()
                        aLock = aLockService.createLock("Event", this.drWB_Event.cif.WB_EVT_ID, {
                            object: {
                                UI_Id: self.drWB_Event.cif.EVENT_ID,
                                Name: self.drWB_Event.cif.EVENT_NAME
                            }
                        })
                    } else
                        aLock = self._Lock
                    await aLock.OnLoaded()
                    await aLock.acquire()
                    self._Lock = aLock
                }

                let aBOis = new PolicyBOis(['Super_User', 'Event_Analyzer'], [], self.WB_Event.cif.WB_CUST_ID_PLANNING, aLock)
                self.PolicyCollection.addPolicy("BOis", aBOis)
                aHasRolePolicy = new PolicyHasRole(self.WB_Event.cif.WB_CUST_ID_PLANNING)
                await aHasRolePolicy.OnLoadComplete
                self.PolicyCollection.addPolicy("HasRole", aHasRolePolicy)
                self._bIHaveSecurityLoaded = true
                return self
            } catch (err) {
                console.log("Unable to setup Security Policies")
                throw err
            }
        })();

        return returnValue
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }


//</editor-fold>

    //<editor-fold desc = "IHaveEventActualsCalculator operations">

    private _EventActualCalculator: EventActualsCalculator

    private IHaveEventActualsCalculator_init(): void {
        this._EventActualCalculator = new EventActualsCalculator()
    }

    private IHaveEventActualsCalculator_OnLoadComplete(): Promise<void> {
        return this._EventActualCalculator.Register(this)
    }

    get ActualsCalculator(): IEventActualsCalculator {
        return this._EventActualCalculator
    }

//</editor-fold>


    //<editor-fold desc = "IHaveEventStandardCalculator operations">


    private _EventStandardCalculator: EventStandardCalculator

    private IHaveEventStandardCalculator_init(): void {
        this._EventStandardCalculator = new EventStandardCalculator()
    }

    private IHaveEventStandardCalculator_OnLoadComplete(): Promise<void> {
        return this._EventStandardCalculator.Register(this)
    }

    get StandardCalculator(): IEventStandardCalculator {
        return this._EventStandardCalculator
    }

//</editor-fold>

    //<editor-fold desc = "IHaveEditorLock
    get EditorLock(): ILock {
        return this._Lock
    }

//</editor-fold>

    //<editor-fold desc = "IHaveRefCounter
    private _refCounter: IRefCounter

    RefCounter_Init(): void {
        this._refCounter = new RefCounter(this)
        this.RefCounter.OnRefCounterChanged.subscribe(this.onRefCounterChanged.bind(this))
    }

    get RefCounter(): IRefCounter {
        return this._refCounter
    }

    private onRefCounterChanged(aRefCounter: IRefCounter): void {
        if (this.RefCounter.RefCount > 0)
            return

        if (_.isEmpty(this.EditorLock))
            return

        if (this.EditorLock.Status === "Locked")
            this.EditorLock.release()
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveEventParentRelationship operations">

    private _EventParentRelationshipsChanged: BehaviorSubject<IHaveEventParentRelationship>
    private _EvtR_RelType_Parent = 'Parent Event ID'


    private IHaveEventParentRelationship_init() {
        this._EventParentRelationshipsChanged = new BehaviorSubject<IHaveEventParentRelationship>(this)
    }

    get EventChildren(): WB_EventRelationshipRow[] {
        const self = this

        return _.filter(this.drWB_Event.WB_EventRelationshipRow_Target, (aRow: WB_EventRelationshipRow) => {
            return (aRow.isActive && (aRow.cif.REL_TYPE == self._EvtR_RelType_Parent))
        })
    }

    get EventParent(): WB_EventRelationshipRow {
        const self = this
        let parentRecs
            = _.filter(self.drWB_Event.WB_EventRelationshipRow_Source,
            (aRow: WB_EventRelationshipRow) => (aRow.isActive && aRow.cif.REL_TYPE == self._EvtR_RelType_Parent));

        let parent = _.first(parentRecs)
        return parent
    }

    async setParent(wbEventId: number): Promise<WB_EventRelationshipRow> {
        const self = this
        //
        let parentRel = self.EventParent
        if (wbEventId == self.drWB_Event.cif.WB_EVT_ID)
            return

        if (wbEventId == parentRel?.WB_EventRow_Target?.cif?.WB_EVT_ID)
            return
        let rr = new ESRecordResolver(self.dbContext, {
            dctExcludeHasManyNamedRelations: {
                [esWB_Event]: ['All']
            },
            dctIncludeBelongsToNamedRelations:
                {[esWB_Event_Override]: [esWB_Metric]},
            standardConditions: {}
        })
        await rr.findAllWithRelationships(esWB_Event, [wbEventId], {})

        let newParent = <WB_EventRow>rr.get(esWB_Event, wbEventId)
        if (_.isEmpty(newParent))
            return

        if (_.isEmpty(parentRel)) {
            parentRel = <WB_EventRelationshipRow>await self.dbContext.createRecordWithKey(esWB_Event_Relationship)
            parentRel.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID
            parentRel.WB_EventRow = self.drWB_Event
            parentRel.cif.REL_TYPE = self._EvtR_RelType_Parent
            parentRel.cif.WB_EVT_ID_REL = wbEventId
            parentRel.WB_EventRow_Target = newParent
            parentRel.cif.MANUAL_IND = '1'
            self.dbContext.add(esWB_Event_Relationship, parentRel)
            parentRel.cif.WB_EVT_ID_REL = wbEventId
        }

        parentRel.cif.WB_EVT_ID_REL = wbEventId
        parentRel.WB_EventRow_Target = newParent

        self.EventParentRelationshipsChanged.next(self)
        return parentRel
    }

    async removeParent(): Promise<IHaveEventParentRelationship> {
        const self = this
        let parentRel = self.EventParent

        if (_.isEmpty(parentRel))
            return

        parentRel.cif.WB_EVT_ID_REL = 0
        parentRel.WB_EventRow_Target = undefined
        self.EventParentRelationshipsChanged.next(self)

        parentRel.markDeleted()

        return self
    }

    get EventParentRelationshipsChanged(): BehaviorSubject<IHaveEventParentRelationship> {
        return this._EventParentRelationshipsChanged
    }

    //</editor-fold>
    //<editor-fold desc = "IHaveEventFunding operations">
    private _EventFundingCollectionChanged: BehaviorSubject<IHaveEventFunding>
    private _EventFRPropertyChanged: BehaviorSubject<IEventFundingChangedEvent>

    private IHaveEventFunding_init() {
        this._EventFundingCollectionChanged = new BehaviorSubject<IHaveEventFunding>(this)
        this._EventFRPropertyChanged = new BehaviorSubject<IEventFundingChangedEvent>(undefined)
    }

    get EventFundingChildren(): WB_EventFRRow[] {
        return _.filter(this.drWB_Event.WB_EventFinanceRelationshipRows, (aRow: WB_EventFRRow) => {
            return (aRow.isActive)
        })
    }

    get EventFundingCollectionChanged(): BehaviorSubject<IHaveEventFunding> {
        return this._EventFundingCollectionChanged
    }

    get EventFRPropertyChanged(): BehaviorSubject<IEventFundingChangedEvent> {
        return this._EventFRPropertyChanged
    }

    async addEventFundingChild(aSourceRow: WB_EventRow): Promise<WB_EventFRRow> {
        const self = this
        let newMetric: WB_MetricRow = undefined

        let drMetrics: WB_MetricRow = <WB_MetricRow>await self.dbContext.createRecordWithKey(esWB_Metric)
        drMetrics.setDefaults()
        drMetrics.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
        drMetrics.cif.WB_PLAN_ID = self.WB_Event.cif.WB_PLAN_ID
        drMetrics.cif.REFERENCE_LEVEL_ID = 'Event'
        drMetrics.cif.METRIC_TYPE_ID = 'Funding'
        drMetrics.cif.REFERENCE_ID = aSourceRow.cif.WB_EVT_ID
        drMetrics.cif.REFERENCE_ID_UI = aSourceRow.cif.EVENT_ID
        drMetrics.cif.WB_PRDGRP_ID = 0;
        self.dbContext.add(esWB_Metric, drMetrics);
        newMetric = drMetrics;

        let aWBLinkedEvent: WB_EventFRRow = <WB_EventFRRow>await self.dbContext.createRecordWithKey(esWB_EventFR)
        if (!(aWBLinkedEvent)) {
            console.log("Unable to create Event Relationship record add to Event. ")
            return
        }
        aWBLinkedEvent.setDefaults()
        aWBLinkedEvent.cif.WB_EVT_ID_REL = aSourceRow.cif.WB_EVT_ID
        aWBLinkedEvent.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
        aWBLinkedEvent.cif.WB_METRIC_ID_FUNDING = newMetric.cif.WB_METRIC_ID
        aWBLinkedEvent.WB_MetricRow_Funding = newMetric
        aWBLinkedEvent.WB_EventRow_Target = aSourceRow
        self.dbContext.add(esWB_EventFR, aWBLinkedEvent)
        self.EventFundingCollectionChanged.next(self)
        return aWBLinkedEvent

    }

    async removeEventFundingChild(wbERId: number): Promise<IHaveEventFunding> {
        const self = this

        for (let aRow of self.WB_Event.WB_EventFinanceRelationshipRows) {
            if (aRow.isActive && aRow.cif.WB_EVTFR_ID == wbERId) {
                aRow.markDeleted()
                self.EventFundingCollectionChanged.next(self)
                return self
            }
        }
    }

    private IEventFunding_onRecordChange(record: WB_EventFRRow, propertyName: string, propertyValue: any, options: EventBO) {
        this.EventFRPropertyChanged.next({
            EventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    private _EventFunding_AfterCreate(anFRRow: WB_EventFRRow): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            this.EventFRPropertyChanged.next({
                EventBO: self,
                Row: anFRRow,
                PropertyChanged: "",
                PropertyValue: undefined
            })
            resolve()
        });

    }

    //</editor-fold>

    //<editor-fold desc = "IHaveCircular">
    private _circulars: ICircularRow[]
    private _circularConfig: WB_CircularConfigRow
    private _bCircularLoaded: boolean

    private IHaveCircular_Init() {
        this._circulars = []
        this._circularConfig = undefined
        this._bCircularLoaded = false
    }

    get Circulars(): ICircularRow[] {
        return this._circulars
    }

    get CircularConfig(): WB_CircularConfigRow {
        return this._circularConfig
    }

    private IHaveCircular_OnLoadComplete(): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            self.OnIHaveCircularLoaded
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

    }


    get OnIHaveCircularLoaded(): Promise<void> {
        const self = this
        return new Promise<void>(async (resolve, error) => {
            try {
                if (self.bCircularLoaded)
                    return
                let dbContext = new PAdbContext()
                let aCircularConfig = this._circularConfig
                this._circulars = []
                _.forEach(self.WB_Event.WB_EventCircularRows, aRow => {
                    if (aRow.isActive && !_.isEmpty(aRow.WB_CircularRow)) {
                        let aCircular: ICircularRow = {
                            Mapped: true,
                            WB_Event_Circular_ID: aRow.cif.WB_EVTCIR_ID,
                            WB_Circular_ID: aRow.cif.WB_CIRCULAR_ID,
                            Date_From: _.toNumber(aRow.WB_CircularRow.cif.SALES_START_DT),//stDate,
                            Date_To: _.toNumber(aRow.WB_CircularRow.cif.SALES_END_DT),//eDate,
                            circularRow: aRow.WB_CircularRow
                        }
                        this._circulars.push(aCircular)
                    }
                })

                if (_.isEmpty(aCircularConfig)) {
                    self._bCircularLoaded = true
                    resolve()
                    return
                }

                //Customer mapping
                let ccCircular: number = await CustomerHierarchyService.getParent(aCircularConfig.cif.WB_CUSTH_ID, self.WB_Event.cif.WB_CUST_ID_PLANNING, self.WB_Event.InStore.Range.StartDt, self.WB_Event.InStore.Range.EndDt)

                let ccCustomer: WB_CustomerRow = undefined
                if (!_.isUndefined(ccCircular))
                    ccCustomer = <WB_CustomerRow>_.first(await self.dbContext.findUsingCache(esWB_Customer, [ccCircular]))
                else {
                    self._bCircularLoaded = true
                    resolve()
                    return
                }


                //Products mapping
                let pgIds: number[] = _.map(self.WB_Event.WB_Event_ProductGroupRows, 'WB_PRDGRP_ID')
                let prodWBIds: number[] = []
                for (let i = 0; i < pgIds.length; i++) {
                    let id = await ProductHierarchyService.getPrdGrpParent(aCircularConfig.cif.WB_PRDH_ID, pgIds[i], self.WB_Event.InStore.Range.StartDt, self.WB_Event.InStore.Range.EndDt)
                    if (!_.isUndefined(id))
                        prodWBIds = _.concat(prodWBIds, id)
                }
                let ccProducts: WB_ProductGroupRow[] = []
                if (prodWBIds.length)
                    ccProducts = <WB_ProductGroupRow[]>await self.dbContext.findUsingCache(esWB_Product_Group, _.uniq(prodWBIds))
                else {
                    resolve()
                    return
                }

                let query: { [id: string]: any } = {}
                query[ccCustomer.cif.CUSTOMER_TYPE] = ccCustomer.cif.CUSTOMER_NAME

                let Levels = _.uniq(_.map(ccProducts, 'cif.LEVEL_ID'))
                let arrPGCondition: any[] = []

                _.forEach(Levels, aLevel => {
                    arrPGCondition.push({[aLevel]: {inq: _.map(_.filter(ccProducts, aPG => aPG.cif.LEVEL_ID == aLevel), 'PRODUCT_GROUP_NAME')}})
                })
                if (Levels.length > 1)
                    query["or"] = arrPGCondition
                else
                    query = _.assign(query, _.first(arrPGCondition))

                if (_.map(this._circulars, 'WB_Circular_ID').length)
                    query["WB_CIRCULAR_ID"] = {nin: _.map(this._circulars, 'WB_Circular_ID')}

                let CCrows = await dbContext.findAll(esWB_Circular, {where: query})
                _.forEach(CCrows, aRow => {
                    if (!_.includes(_.map(this._circulars, 'WB_Circular_ID'), aRow.cif.WB_CIRCULAR_ID)) {
                        let aCircular: ICircularRow = {
                            Mapped: false,
                            WB_Event_Circular_ID: 0,
                            WB_Circular_ID: aRow.cif.WB_CIRCULAR_ID,
                            Date_From: aRow.cif.SALES_START_DT,//stDate,
                            Date_To: aRow.cif.SALES_END_DT,//eDate,
                            circularRow: aRow
                        }
                        this._circulars.push(aCircular)
                    }
                })
                self._bCircularLoaded = true
                resolve()
            } catch (e) {
                console.log("Can't load circular " + e.toString())
                resolve()
            }
        })

    }

    get bCircularLoaded(): boolean {
        return this._bCircularLoaded
    }

    async getCircularConfig(wbBUId: number): Promise<WB_CircularConfigRow> {
        const self = this
        let returnVal: WB_CircularConfigRow = undefined
        if (!(wbBUId > 0))
            return undefined

        let BURow: WB_BusinessUnitRow = <WB_BusinessUnitRow>await self.dbContext.find(esWB_BusinessUnit, wbBUId)
        if (!_.isEmpty(BURow))
            returnVal = <WB_CircularConfigRow>await self.dbContext.find(esWB_Circular_Config, BURow.cif.WB_CIRCULARCONFIG_ID)

        return returnVal

    }

    addEventCircular(wbCircularId: number): Promise<WB_EventCircularRow> {
        const self = this

        return new Promise<WB_EventCircularRow>((resolve, error) => {
            let found: WB_EventCircularRow = undefined
            _.forEach(self.WB_Event.WB_EventCircularRows, aRow => {
                if (aRow.cif.WB_CIRCULAR_ID == wbCircularId) {
                    aRow.cif.DELETED_IND = '0'
                    found = aRow
                    return false
                }
            })
            if (!_.isEmpty(found)) {
                resolve(found)
                return
            }

            self.dbContext.createRecordWithKey(esWB_Event_Circular)
                .then((aWBEventCircular: WB_EventCircularRow) => {
                    //
                    if (!(aWBEventCircular)) {
                        error("Unable to create Event Circular record add to Event. ")
                        return
                    }
                    aWBEventCircular.setDefaults()
                    aWBEventCircular.cif.WB_CIRCULAR_ID = wbCircularId
                    aWBEventCircular.cif.WB_EVT_ID = self.WB_Event.cif.WB_EVT_ID
                    self.dbContext.add(esWB_Event_Circular, aWBEventCircular)
                    resolve(aWBEventCircular)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeEventCircular(wbEventCircularId: number): void {
        const self = this

        if (_.isEmpty(self.WB_Event))
            return

        _.forEach(self.WB_Event.WB_EventCircularRows, aCircular => {
            if (aCircular.isActive && aCircular.cif.WB_EVTCIR_ID == wbEventCircularId)
                aCircular.markDeleted()
        })

        return
    }

    async updateEventCirculars(): Promise<void> {
        const self = this
        _.forEach(_.filter(self.Circulars, aCircular => !aCircular.Mapped && aCircular.WB_Event_Circular_ID > 0), aDeletedRow => {
            self.removeEventCircular(aDeletedRow.WB_Event_Circular_ID)
        })

        let toAdd = _.filter(self.Circulars, aCircular => aCircular.Mapped && aCircular.WB_Event_Circular_ID == -1)
        for (let i = 0; i < toAdd.length; i++) {
            let anAddedRow = toAdd[i]
            let aNewRow = await self.addEventCircular(anAddedRow.WB_Circular_ID)
            anAddedRow.WB_Event_Circular_ID = aNewRow.cif.WB_EVTCIR_ID
        }
        return
    }

    async addEvtShipPrd(aWB_PROD_ID: number): Promise<WB_EvtShipPrdRow> {
        let self = this
        let aWBEvtShipPrd: WB_EvtShipPrdRow = <WB_EvtShipPrdRow>await self.dbContext.createRecordWithKey(esWB_EvtShipPrd)
        if (!(aWBEvtShipPrd)) {
            console.log("Unable to create Event Shipper Product record to Event. ")
            return
        }

        let aPrdRecord = await self.dbContext.find(esWB_Finished_Product, aWB_PROD_ID)

        if (!aPrdRecord)
            return

        let allEvtShipPrds = self.dbContext.getAll(esWB_EvtShipPrd)
        let duplicate = false
        _.forEach(allEvtShipPrds, (evt) => {
            if (evt.isActive && evt.cif.WB_PROD_ID === aWB_PROD_ID) {
                duplicate = true
                return
            }
        })
        if (duplicate) {
            // @ts-ignore
            sap.m.MessageBox.error("Duplicate Product cannot be added");
            return
        }
        aWBEvtShipPrd.setDefaults()
        aWBEvtShipPrd.cif.WB_EVT_ID = self.drWB_Event.cif.WB_EVT_ID;
        aWBEvtShipPrd.cif.WB_PROD_ID = aWB_PROD_ID
        aWBEvtShipPrd.WB_FinishedProductRow = aPrdRecord
        self.dbContext.add(esWB_EvtShipPrd, aWBEvtShipPrd)

    }

    async removeEvtShipPrd(aWB_EvtShipPrd_ID: number): Promise<EventBO> {
        const self = this

        _.forEach(this.drWB_Event.WB_EvtShipPrdRows, (aRow: WB_EvtShipPrdRow) => {
            if (aRow.isActive) {
                if (aRow.cif.WB_EVTSHIPPRD_ID == aWB_EvtShipPrd_ID) {
                    aRow.markDeleted()
                    _.forEach(aRow.WB_EvtShipCPrdRows, (row) => {
                        row.markDeleted()
                    })
                }
            }
        })

        return self

    }

    //</editor-fold>
    //<editor-fold desc = "IRecordResolverProvider   <<STATIC>> operations">


    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('Plan' in opts) {
            dbContext = opts.Plan.dbContext
        } else if ('dbContext' in opts)
            dbContext = opts.dbContext;
        else {
            dbContext = new PAdbContext({});
        }
        const evt_options: CreateOptions = {
            standardConditions: {
                [esWB_Event]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Product_Group]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Spend_PrdGrp]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Product]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Spend_Prd]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Spend_PrdGrp_Customer]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Customer]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Meta]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Circular]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Event_Tag]: {"DELETED_IND": {"notIn": ['1']}}
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Event_Spend_PrdGrp]: [esWB_Event_Spend_Prd, esWB_Event_Spend_PrdGrp_Customer, esWB_Event_Spend_PrdGrp_Override],
                [esWB_Event_Spend_PrdGrp_Override]: [esWB_Metric],
                [esWB_Plan]: [esWB_Plan_Type],
                [esWB_Event_Relationship]: [esWB_Event],
                [esWB_Event]: [esWB_Meta, esWB_Event_Type, esWB_Customer, esWB_Plan],
                [esWB_Event_Circular]: [esWB_Circular],
                [esWB_EventFR]: [esWB_Metric]
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, evt_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Event, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })

    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

//</editor-fold>

};

PAEnvironment.registerBusinessObjectClass(EventBO, "EventBO", "Event");
